export const countyList = [
    { state: 'AL', county: 'Autauga' },
    { state: 'AL', county: 'Baldwin' },
    { state: 'AL', county: 'Barbour' },
    { state: 'AL', county: 'Bibb' },
    { state: 'AL', county: 'Blount' },
    { state: 'AL', county: 'Bullock' },
    { state: 'AL', county: 'Butler' },
    { state: 'AL', county: 'Calhoun' },
    { state: 'AL', county: 'Chambers' },
    { state: 'AL', county: 'Cherokee' },
    { state: 'AL', county: 'Chilton' },
    { state: 'AL', county: 'Choctaw' },
    { state: 'AL', county: 'Clarke' },
    { state: 'AL', county: 'Clay' },
    { state: 'AL', county: 'Cleburne' },
    { state: 'AL', county: 'Coffee' },
    { state: 'AL', county: 'Colbert' },
    { state: 'AL', county: 'Conecuh' },
    { state: 'AL', county: 'Coosa' },
    { state: 'AL', county: 'Covington' },
    { state: 'AL', county: 'Crenshaw' },
    { state: 'AL', county: 'Cullman' },
    { state: 'AL', county: 'Dale' },
    { state: 'AL', county: 'Dallas' },
    { state: 'AL', county: 'De Kalb' },
    { state: 'AL', county: 'Elmore' },
    { state: 'AL', county: 'Escambia' },
    { state: 'AL', county: 'Etowah' },
    { state: 'AL', county: 'Fayette' },
    { state: 'AL', county: 'Franklin' },
    { state: 'AL', county: 'Geneva' },
    { state: 'AL', county: 'Greene' },
    { state: 'AL', county: 'Hale' },
    { state: 'AL', county: 'Henry' },
    { state: 'AL', county: 'Houston' },
    { state: 'AL', county: 'Jackson' },
    { state: 'AL', county: 'Jefferson' },
    { state: 'AL', county: 'Lamar' },
    { state: 'AL', county: 'Lauderdale' },
    { state: 'AL', county: 'Lawrence' },
    { state: 'AL', county: 'Lee' },
    { state: 'AL', county: 'Limestone' },
    { state: 'AL', county: 'Lowndes' },
    { state: 'AL', county: 'Macon' },
    { state: 'AL', county: 'Madison' },
    { state: 'AL', county: 'Marengo' },
    { state: 'AL', county: 'Marion' },
    { state: 'AL', county: 'Marshall' },
    { state: 'AL', county: 'Mobile' },
    { state: 'AL', county: 'Monroe' },
    { state: 'AL', county: 'Montgomery' },
    { state: 'AL', county: 'Morgan' },
    { state: 'AL', county: 'Perry' },
    { state: 'AL', county: 'Pickens' },
    { state: 'AL', county: 'Pike' },
    { state: 'AL', county: 'Randolph' },
    { state: 'AL', county: 'Russell' },
    { state: 'AL', county: 'St. Clair' },
    { state: 'AL', county: 'Shelby' },
    { state: 'AL', county: 'Sumter' },
    { state: 'AL', county: 'Talladega' },
    { state: 'AL', county: 'Tallapoosa' },
    { state: 'AL', county: 'Tuscaloosa' },
    { state: 'AL', county: 'Walker' },
    { state: 'AL', county: 'Washington' },
    { state: 'AL', county: 'Wilcox' },
    { state: 'AL', county: 'Winston' },
    { state: 'AK', county: 'Aleutians East' },
    { state: 'AK', county: 'Anchorage' },
    { state: 'AK', county: 'Bristol Bay' },
    { state: 'AK', county: 'Denali' },
    { state: 'AK', county: 'Fairbanks North Star' },
    { state: 'AK', county: 'Haines' },
    { state: 'AK', county: 'Juneau' },
    { state: 'AK', county: 'Kenai Peninsula' },
    { state: 'AK', county: 'Ketchikan Gateway' },
    { state: 'AK', county: 'Kodiak Island' },
    { state: 'AK', county: 'Lake And Peninsula' },
    { state: 'AK', county: 'Matanuska-Susitna' },
    { state: 'AK', county: 'North Slope' },
    { state: 'AK', county: 'Northwest Arctic' },
    { state: 'AK', county: 'Petersberg' },
    { state: 'AK', county: 'Sitka' },
    { state: 'AK', county: 'Skagway' },
    { state: 'AK', county: 'Wrangell' },
    { state: 'AK', county: 'Yakutat' },
    { state: 'AZ', county: 'Apache' },
    { state: 'AZ', county: 'Cochise' },
    { state: 'AZ', county: 'Coconino' },
    { state: 'AZ', county: 'Gila' },
    { state: 'AZ', county: 'Graham' },
    { state: 'AZ', county: 'Greenlee' },
    { state: 'AZ', county: 'La Paz' },
    { state: 'AZ', county: 'Maricopa' },
    { state: 'AZ', county: 'Mohave' },
    { state: 'AZ', county: 'Navajo' },
    { state: 'AZ', county: 'Pima' },
    { state: 'AZ', county: 'Pinal' },
    { state: 'AZ', county: 'Santa Cruz' },
    { state: 'AZ', county: 'Yavapai' },
    { state: 'AZ', county: 'Yuma' },
    { state: 'AR', county: 'Arkansas' },
    { state: 'AR', county: 'Ashley' },
    { state: 'AR', county: 'Baxter' },
    { state: 'AR', county: 'Benton' },
    { state: 'AR', county: 'Boone' },
    { state: 'AR', county: 'Bradley' },
    { state: 'AR', county: 'Calhoun' },
    { state: 'AR', county: 'Carroll' },
    { state: 'AR', county: 'Chicot' },
    { state: 'AR', county: 'Clark' },
    { state: 'AR', county: 'Clay' },
    { state: 'AR', county: 'Cleburne' },
    { state: 'AR', county: 'Cleveland' },
    { state: 'AR', county: 'Columbia' },
    { state: 'AR', county: 'Conway' },
    { state: 'AR', county: 'Craighead' },
    { state: 'AR', county: 'Crawford' },
    { state: 'AR', county: 'Crittenden' },
    { state: 'AR', county: 'Cross' },
    { state: 'AR', county: 'Dallas' },
    { state: 'AR', county: 'Desha' },
    { state: 'AR', county: 'Drew' },
    { state: 'AR', county: 'Faulkner' },
    { state: 'AR', county: 'Franklin' },
    { state: 'AR', county: 'Fulton' },
    { state: 'AR', county: 'Garland' },
    { state: 'AR', county: 'Grant' },
    { state: 'AR', county: 'Greene' },
    { state: 'AR', county: 'Hempstead' },
    { state: 'AR', county: 'Hot Spring' },
    { state: 'AR', county: 'Howard' },
    { state: 'AR', county: 'Independence' },
    { state: 'AR', county: 'Izard' },
    { state: 'AR', county: 'Jackson' },
    { state: 'AR', county: 'Jefferson' },
    { state: 'AR', county: 'Johnson' },
    { state: 'AR', county: 'Lafayette' },
    { state: 'AR', county: 'Lawrence' },
    { state: 'AR', county: 'Lee' },
    { state: 'AR', county: 'Lincoln' },
    { state: 'AR', county: 'Little River' },
    { state: 'AR', county: 'Logan' },
    { state: 'AR', county: 'Lonoke' },
    { state: 'AR', county: 'Madison' },
    { state: 'AR', county: 'Marion' },
    { state: 'AR', county: 'Miller' },
    { state: 'AR', county: 'Mississippi' },
    { state: 'AR', county: 'Monroe' },
    { state: 'AR', county: 'Montgomery' },
    { state: 'AR', county: 'Nevada' },
    { state: 'AR', county: 'Newton' },
    { state: 'AR', county: 'Ouachita' },
    { state: 'AR', county: 'Perry' },
    { state: 'AR', county: 'Phillips' },
    { state: 'AR', county: 'Pike' },
    { state: 'AR', county: 'Poinsett' },
    { state: 'AR', county: 'Polk' },
    { state: 'AR', county: 'Pope' },
    { state: 'AR', county: 'Prairie' },
    { state: 'AR', county: 'Pulaski' },
    { state: 'AR', county: 'Randolph' },
    { state: 'AR', county: 'St. Francis' },
    { state: 'AR', county: 'Saline' },
    { state: 'AR', county: 'Scott' },
    { state: 'AR', county: 'Searcy' },
    { state: 'AR', county: 'Sebastian' },
    { state: 'AR', county: 'Sevier' },
    { state: 'AR', county: 'Sharp' },
    { state: 'AR', county: 'Stone' },
    { state: 'AR', county: 'Union' },
    { state: 'AR', county: 'Van Buren' },
    { state: 'AR', county: 'Washington' },
    { state: 'AR', county: 'White' },
    { state: 'AR', county: 'Woodruff' },
    { state: 'AR', county: 'Yell' },
    { state: 'CA', county: 'Alameda' },
    { state: 'CA', county: 'Alpine' },
    { state: 'CA', county: 'Amador' },
    { state: 'CA', county: 'Butte' },
    { state: 'CA', county: 'Calaveras' },
    { state: 'CA', county: 'Colusa' },
    { state: 'CA', county: 'Contra Costa' },
    { state: 'CA', county: 'Del Norte' },
    { state: 'CA', county: 'El Dorado' },
    { state: 'CA', county: 'Fresno' },
    { state: 'CA', county: 'Glenn' },
    { state: 'CA', county: 'Humboldt' },
    { state: 'CA', county: 'Imperial' },
    { state: 'CA', county: 'Inyo' },
    { state: 'CA', county: 'Kern' },
    { state: 'CA', county: 'Kings' },
    { state: 'CA', county: 'Lake' },
    { state: 'CA', county: 'Lassen' },
    { state: 'CA', county: 'Los Angeles' },
    { state: 'CA', county: 'Madera' },
    { state: 'CA', county: 'Marin' },
    { state: 'CA', county: 'Mariposa' },
    { state: 'CA', county: 'Mendocino' },
    { state: 'CA', county: 'Merced' },
    { state: 'CA', county: 'Modoc' },
    { state: 'CA', county: 'Mono' },
    { state: 'CA', county: 'Monterey' },
    { state: 'CA', county: 'Napa' },
    { state: 'CA', county: 'Nevada' },
    { state: 'CA', county: 'Orange' },
    { state: 'CA', county: 'Placer' },
    { state: 'CA', county: 'Plumas' },
    { state: 'CA', county: 'Riverside' },
    { state: 'CA', county: 'Sacramento' },
    { state: 'CA', county: 'San Benito' },
    { state: 'CA', county: 'San Bernardino' },
    { state: 'CA', county: 'San Diego' },
    { state: 'CA', county: 'San Francisco' },
    { state: 'CA', county: 'San Joaquin' },
    { state: 'CA', county: 'San Luis Obispo' },
    { state: 'CA', county: 'San Mateo' },
    { state: 'CA', county: 'Santa Barbara' },
    { state: 'CA', county: 'Santa Clara' },
    { state: 'CA', county: 'Santa Cruz' },
    { state: 'CA', county: 'Shasta' },
    { state: 'CA', county: 'Sierra' },
    { state: 'CA', county: 'Siskiyou' },
    { state: 'CA', county: 'Solano' },
    { state: 'CA', county: 'Sonoma' },
    { state: 'CA', county: 'Stanislaus' },
    { state: 'CA', county: 'Sutter' },
    { state: 'CA', county: 'Tehama' },
    { state: 'CA', county: 'Trinity' },
    { state: 'CA', county: 'Tulare' },
    { state: 'CA', county: 'Tuolumne' },
    { state: 'CA', county: 'Ventura' },
    { state: 'CA', county: 'Yolo' },
    { state: 'CA', county: 'Yuba' },
    { state: 'CO', county: 'Adams' },
    { state: 'CO', county: 'Alamosa' },
    { state: 'CO', county: 'Arapahoe' },
    { state: 'CO', county: 'Archuleta' },
    { state: 'CO', county: 'Baca' },
    { state: 'CO', county: 'Bent' },
    { state: 'CO', county: 'Boulder' },
    { state: 'CO', county: 'Broomfield' },
    { state: 'CO', county: 'Chaffee' },
    { state: 'CO', county: 'Cheyenne' },
    { state: 'CO', county: 'Clear Creek' },
    { state: 'CO', county: 'Conejos' },
    { state: 'CO', county: 'Costilla' },
    { state: 'CO', county: 'Crowley' },
    { state: 'CO', county: 'Custer' },
    { state: 'CO', county: 'Delta' },
    { state: 'CO', county: 'Denver' },
    { state: 'CO', county: 'Dolores' },
    { state: 'CO', county: 'Douglas' },
    { state: 'CO', county: 'Eagle' },
    { state: 'CO', county: 'Elbert' },
    { state: 'CO', county: 'El Paso' },
    { state: 'CO', county: 'Fremont' },
    { state: 'CO', county: 'Garfield' },
    { state: 'CO', county: 'Gilpin' },
    { state: 'CO', county: 'Grand' },
    { state: 'CO', county: 'Gunnison' },
    { state: 'CO', county: 'Hinsdale' },
    { state: 'CO', county: 'Huerfano' },
    { state: 'CO', county: 'Jackson' },
    { state: 'CO', county: 'Jefferson' },
    { state: 'CO', county: 'Kiowa' },
    { state: 'CO', county: 'Kit Carson' },
    { state: 'CO', county: 'Lake' },
    { state: 'CO', county: 'La Plata' },
    { state: 'CO', county: 'Larimer' },
    { state: 'CO', county: 'Las Animas' },
    { state: 'CO', county: 'Lincoln' },
    { state: 'CO', county: 'Logan' },
    { state: 'CO', county: 'Mesa' },
    { state: 'CO', county: 'Mineral' },
    { state: 'CO', county: 'Moffat' },
    { state: 'CO', county: 'Montezuma' },
    { state: 'CO', county: 'Montrose' },
    { state: 'CO', county: 'Morgan' },
    { state: 'CO', county: 'Otero' },
    { state: 'CO', county: 'Ouray' },
    { state: 'CO', county: 'Park' },
    { state: 'CO', county: 'Phillips' },
    { state: 'CO', county: 'Pitkin' },
    { state: 'CO', county: 'Prowers' },
    { state: 'CO', county: 'Pueblo' },
    { state: 'CO', county: 'Rio Blanco' },
    { state: 'CO', county: 'Rio Grande' },
    { state: 'CO', county: 'Routt' },
    { state: 'CO', county: 'Saguache' },
    { state: 'CO', county: 'San Juan' },
    { state: 'CO', county: 'San Miguel' },
    { state: 'CO', county: 'Sedgwick' },
    { state: 'CO', county: 'Summit' },
    { state: 'CO', county: 'Teller' },
    { state: 'CO', county: 'Washington' },
    { state: 'CO', county: 'Weld' },
    { state: 'CO', county: 'Yuma' },
    { state: 'CT', county: 'Fairfield' },
    { state: 'CT', county: 'Hartford' },
    { state: 'CT', county: 'Litchfield' },
    { state: 'CT', county: 'Middlesex' },
    { state: 'CT', county: 'New Haven' },
    { state: 'CT', county: 'New London' },
    { state: 'CT', county: 'Tolland' },
    { state: 'CT', county: 'Windham' },
    { state: 'DE', county: 'Kent' },
    { state: 'DE', county: 'New Castle' },
    { state: 'DE', county: 'Sussex' },
    { state: 'DC', county: 'District Of Columbia' },
    { state: 'FL', county: 'Alachua' },
    { state: 'FL', county: 'Baker' },
    { state: 'FL', county: 'Bay' },
    { state: 'FL', county: 'Bradford' },
    { state: 'FL', county: 'Brevard' },
    { state: 'FL', county: 'Broward' },
    { state: 'FL', county: 'Calhoun' },
    { state: 'FL', county: 'Charlotte' },
    { state: 'FL', county: 'Citrus' },
    { state: 'FL', county: 'Clay' },
    { state: 'FL', county: 'Collier' },
    { state: 'FL', county: 'Columbia' },
    { state: 'FL', county: 'DeSoto' },
    { state: 'FL', county: 'Dixie' },
    { state: 'FL', county: 'Duval' },
    { state: 'FL', county: 'Escambia' },
    { state: 'FL', county: 'Flagler' },
    { state: 'FL', county: 'Franklin' },
    { state: 'FL', county: 'Gadsden' },
    { state: 'FL', county: 'Gilchrist' },
    { state: 'FL', county: 'Glades' },
    { state: 'FL', county: 'Gulf' },
    { state: 'FL', county: 'Hamilton' },
    { state: 'FL', county: 'Hardee' },
    { state: 'FL', county: 'Hendry' },
    { state: 'FL', county: 'Hernando' },
    { state: 'FL', county: 'Highlands' },
    { state: 'FL', county: 'Hillsborough' },
    { state: 'FL', county: 'Holmes' },
    { state: 'FL', county: 'Indian River' },
    { state: 'FL', county: 'Jackson' },
    { state: 'FL', county: 'Jefferson' },
    { state: 'FL', county: 'Lafayette' },
    { state: 'FL', county: 'Lake' },
    { state: 'FL', county: 'Lee' },
    { state: 'FL', county: 'Leon' },
    { state: 'FL', county: 'Levy' },
    { state: 'FL', county: 'Liberty' },
    { state: 'FL', county: 'Madison' },
    { state: 'FL', county: 'Manatee' },
    { state: 'FL', county: 'Marion' },
    { state: 'FL', county: 'Martin' },
    { state: 'FL', county: 'Miami-Dade' },
    { state: 'FL', county: 'Monroe' },
    { state: 'FL', county: 'Nassau' },
    { state: 'FL', county: 'Okaloosa' },
    { state: 'FL', county: 'Okeechobee' },
    { state: 'FL', county: 'Orange' },
    { state: 'FL', county: 'Osceola' },
    { state: 'FL', county: 'Palm Beach' },
    { state: 'FL', county: 'Pasco' },
    { state: 'FL', county: 'Pinellas' },
    { state: 'FL', county: 'Polk' },
    { state: 'FL', county: 'Putnam' },
    { state: 'FL', county: 'St. Johns' },
    { state: 'FL', county: 'St. Lucie' },
    { state: 'FL', county: 'Santa Rosa' },
    { state: 'FL', county: 'Sarasota' },
    { state: 'FL', county: 'Seminole' },
    { state: 'FL', county: 'Sumter' },
    { state: 'FL', county: 'Suwannee' },
    { state: 'FL', county: 'Taylor' },
    { state: 'FL', county: 'Union' },
    { state: 'FL', county: 'Volusia' },
    { state: 'FL', county: 'Wakulla' },
    { state: 'FL', county: 'Walton' },
    { state: 'FL', county: 'Washington' },
    { state: 'GA', county: 'Appling' },
    { state: 'GA', county: 'Atkinson' },
    { state: 'GA', county: 'Bacon' },
    { state: 'GA', county: 'Baker' },
    { state: 'GA', county: 'Baldwin' },
    { state: 'GA', county: 'Banks' },
    { state: 'GA', county: 'Barrow' },
    { state: 'GA', county: 'Bartow' },
    { state: 'GA', county: 'Ben Hill' },
    { state: 'GA', county: 'Berrien' },
    { state: 'GA', county: 'Bibb' },
    { state: 'GA', county: 'Bleckley' },
    { state: 'GA', county: 'Brantley' },
    { state: 'GA', county: 'Brooks' },
    { state: 'GA', county: 'Bryan' },
    { state: 'GA', county: 'Bulloch' },
    { state: 'GA', county: 'Burke' },
    { state: 'GA', county: 'Butts' },
    { state: 'GA', county: 'Calhoun' },
    { state: 'GA', county: 'Camden' },
    { state: 'GA', county: 'Candler' },
    { state: 'GA', county: 'Carroll' },
    { state: 'GA', county: 'Catoosa' },
    { state: 'GA', county: 'Charlton' },
    { state: 'GA', county: 'Chatham' },
    { state: 'GA', county: 'Chattahoochee' },
    { state: 'GA', county: 'Chattooga' },
    { state: 'GA', county: 'Cherokee' },
    { state: 'GA', county: 'Clarke' },
    { state: 'GA', county: 'Clay' },
    { state: 'GA', county: 'Clayton' },
    { state: 'GA', county: 'Clinch' },
    { state: 'GA', county: 'Cobb' },
    { state: 'GA', county: 'Coffee' },
    { state: 'GA', county: 'Colquitt' },
    { state: 'GA', county: 'Columbia' },
    { state: 'GA', county: 'Cook' },
    { state: 'GA', county: 'Coweta' },
    { state: 'GA', county: 'Crawford' },
    { state: 'GA', county: 'Crisp' },
    { state: 'GA', county: 'Dade' },
    { state: 'GA', county: 'Dawson' },
    { state: 'GA', county: 'De Kalb' },
    { state: 'GA', county: 'Decatur' },
    { state: 'GA', county: 'Dodge' },
    { state: 'GA', county: 'Dooly' },
    { state: 'GA', county: 'Dougherty' },
    { state: 'GA', county: 'Douglas' },
    { state: 'GA', county: 'Early' },
    { state: 'GA', county: 'Echols' },
    { state: 'GA', county: 'Effingham' },
    { state: 'GA', county: 'Elbert' },
    { state: 'GA', county: 'Emanuel' },
    { state: 'GA', county: 'Evans' },
    { state: 'GA', county: 'Fannin' },
    { state: 'GA', county: 'Fayette' },
    { state: 'GA', county: 'Floyd' },
    { state: 'GA', county: 'Forsyth' },
    { state: 'GA', county: 'Franklin' },
    { state: 'GA', county: 'Fulton' },
    { state: 'GA', county: 'Gilmer' },
    { state: 'GA', county: 'Glascock' },
    { state: 'GA', county: 'Glynn' },
    { state: 'GA', county: 'Gordon' },
    { state: 'GA', county: 'Grady' },
    { state: 'GA', county: 'Greene' },
    { state: 'GA', county: 'Gwinnett' },
    { state: 'GA', county: 'Habersham' },
    { state: 'GA', county: 'Hall' },
    { state: 'GA', county: 'Hancock' },
    { state: 'GA', county: 'Haralson' },
    { state: 'GA', county: 'Harris' },
    { state: 'GA', county: 'Hart' },
    { state: 'GA', county: 'Heard' },
    { state: 'GA', county: 'Henry' },
    { state: 'GA', county: 'Houston' },
    { state: 'GA', county: 'Irwin' },
    { state: 'GA', county: 'Jackson' },
    { state: 'GA', county: 'Jasper' },
    { state: 'GA', county: 'Jeff Davis' },
    { state: 'GA', county: 'Jefferson' },
    { state: 'GA', county: 'Jenkins' },
    { state: 'GA', county: 'Johnson' },
    { state: 'GA', county: 'Jones' },
    { state: 'GA', county: 'Lamar' },
    { state: 'GA', county: 'Lanier' },
    { state: 'GA', county: 'Laurens' },
    { state: 'GA', county: 'Lee' },
    { state: 'GA', county: 'Liberty' },
    { state: 'GA', county: 'Lincoln' },
    { state: 'GA', county: 'Long' },
    { state: 'GA', county: 'Lowndes' },
    { state: 'GA', county: 'Lumpkin' },
    { state: 'GA', county: 'Macon' },
    { state: 'GA', county: 'Madison' },
    { state: 'GA', county: 'Marion' },
    { state: 'GA', county: 'McDuffie' },
    { state: 'GA', county: 'McIntosh' },
    { state: 'GA', county: 'Meriwether' },
    { state: 'GA', county: 'Miller' },
    { state: 'GA', county: 'Mitchell' },
    { state: 'GA', county: 'Monroe' },
    { state: 'GA', county: 'Montgomery' },
    { state: 'GA', county: 'Morgan' },
    { state: 'GA', county: 'Murray' },
    { state: 'GA', county: 'Muscogee' },
    { state: 'GA', county: 'Newton' },
    { state: 'GA', county: 'Oconee' },
    { state: 'GA', county: 'Oglethorpe' },
    { state: 'GA', county: 'Paulding' },
    { state: 'GA', county: 'Peach' },
    { state: 'GA', county: 'Pickens' },
    { state: 'GA', county: 'Pierce' },
    { state: 'GA', county: 'Pike' },
    { state: 'GA', county: 'Polk' },
    { state: 'GA', county: 'Pulaski' },
    { state: 'GA', county: 'Putnam' },
    { state: 'GA', county: 'Quitman' },
    { state: 'GA', county: 'Rabun' },
    { state: 'GA', county: 'Randolph' },
    { state: 'GA', county: 'Richmond' },
    { state: 'GA', county: 'Rockdale' },
    { state: 'GA', county: 'Schley' },
    { state: 'GA', county: 'Screven' },
    { state: 'GA', county: 'Seminole' },
    { state: 'GA', county: 'Spalding' },
    { state: 'GA', county: 'Stephens' },
    { state: 'GA', county: 'Stewart' },
    { state: 'GA', county: 'Sumter' },
    { state: 'GA', county: 'Talbot' },
    { state: 'GA', county: 'Taliaferro' },
    { state: 'GA', county: 'Tattnall' },
    { state: 'GA', county: 'Taylor' },
    { state: 'GA', county: 'Telfair' },
    { state: 'GA', county: 'Terrell' },
    { state: 'GA', county: 'Thomas' },
    { state: 'GA', county: 'Tift' },
    { state: 'GA', county: 'Toombs' },
    { state: 'GA', county: 'Towns' },
    { state: 'GA', county: 'Treutlen' },
    { state: 'GA', county: 'Troup' },
    { state: 'GA', county: 'Turner' },
    { state: 'GA', county: 'Twiggs' },
    { state: 'GA', county: 'Union' },
    { state: 'GA', county: 'Upson' },
    { state: 'GA', county: 'Walker' },
    { state: 'GA', county: 'Walton' },
    { state: 'GA', county: 'Ware' },
    { state: 'GA', county: 'Warren' },
    { state: 'GA', county: 'Washington' },
    { state: 'GA', county: 'Wayne' },
    { state: 'GA', county: 'Webster' },
    { state: 'GA', county: 'Wheeler' },
    { state: 'GA', county: 'White' },
    { state: 'GA', county: 'Whitfield' },
    { state: 'GA', county: 'Wilcox' },
    { state: 'GA', county: 'Wilkes' },
    { state: 'GA', county: 'Wilkinson' },
    { state: 'GA', county: 'Worth' },
    { state: 'HI', county: 'Hawaii' },
    { state: 'HI', county: 'Honolulu' },
    { state: 'HI', county: 'Kalawao' },
    { state: 'HI', county: 'Kauai' },
    { state: 'HI', county: 'Maui' },
    { state: 'ID', county: 'Ada' },
    { state: 'ID', county: 'Adams' },
    { state: 'ID', county: 'Bannock' },
    { state: 'ID', county: 'Bear Lake' },
    { state: 'ID', county: 'Benewah' },
    { state: 'ID', county: 'Bingham' },
    { state: 'ID', county: 'Blaine' },
    { state: 'ID', county: 'Boise' },
    { state: 'ID', county: 'Bonner' },
    { state: 'ID', county: 'Bonneville' },
    { state: 'ID', county: 'Boundary' },
    { state: 'ID', county: 'Butte' },
    { state: 'ID', county: 'Camas' },
    { state: 'ID', county: 'Canyon' },
    { state: 'ID', county: 'Caribou' },
    { state: 'ID', county: 'Cassia' },
    { state: 'ID', county: 'Clark' },
    { state: 'ID', county: 'Clearwater' },
    { state: 'ID', county: 'Custer' },
    { state: 'ID', county: 'Elmore' },
    { state: 'ID', county: 'Franklin' },
    { state: 'ID', county: 'Fremont' },
    { state: 'ID', county: 'Gem' },
    { state: 'ID', county: 'Gooding' },
    { state: 'ID', county: 'Idaho' },
    { state: 'ID', county: 'Jefferson' },
    { state: 'ID', county: 'Jerome' },
    { state: 'ID', county: 'Kootenai' },
    { state: 'ID', county: 'Latah' },
    { state: 'ID', county: 'Lemhi' },
    { state: 'ID', county: 'Lewis' },
    { state: 'ID', county: 'Lincoln' },
    { state: 'ID', county: 'Madison' },
    { state: 'ID', county: 'Minidoka' },
    { state: 'ID', county: 'Nez Perce' },
    { state: 'ID', county: 'Oneida' },
    { state: 'ID', county: 'Owyhee' },
    { state: 'ID', county: 'Payette' },
    { state: 'ID', county: 'Power' },
    { state: 'ID', county: 'Shoshone' },
    { state: 'ID', county: 'Teton' },
    { state: 'ID', county: 'Twin Falls' },
    { state: 'ID', county: 'Valley' },
    { state: 'ID', county: 'Washington' },
    { state: 'IL', county: 'Adams' },
    { state: 'IL', county: 'Alexander' },
    { state: 'IL', county: 'Bond' },
    { state: 'IL', county: 'Boone' },
    { state: 'IL', county: 'Brown' },
    { state: 'IL', county: 'Bureau' },
    { state: 'IL', county: 'Calhoun' },
    { state: 'IL', county: 'Carroll' },
    { state: 'IL', county: 'Cass' },
    { state: 'IL', county: 'Champaign' },
    { state: 'IL', county: 'Christian' },
    { state: 'IL', county: 'Clark' },
    { state: 'IL', county: 'Clay' },
    { state: 'IL', county: 'Clinton' },
    { state: 'IL', county: 'Coles' },
    { state: 'IL', county: 'Cook' },
    { state: 'IL', county: 'Crawford' },
    { state: 'IL', county: 'Cumberland' },
    { state: 'IL', county: 'DeKalb' },
    { state: 'IL', county: 'De Witt' },
    { state: 'IL', county: 'Douglas' },
    { state: 'IL', county: 'DuPage' },
    { state: 'IL', county: 'Edgar' },
    { state: 'IL', county: 'Edwards' },
    { state: 'IL', county: 'Effingham' },
    { state: 'IL', county: 'Fayette' },
    { state: 'IL', county: 'Ford' },
    { state: 'IL', county: 'Franklin' },
    { state: 'IL', county: 'Fulton' },
    { state: 'IL', county: 'Gallatin' },
    { state: 'IL', county: 'Greene' },
    { state: 'IL', county: 'Grundy' },
    { state: 'IL', county: 'Hamilton' },
    { state: 'IL', county: 'Hancock' },
    { state: 'IL', county: 'Hardin' },
    { state: 'IL', county: 'Henderson' },
    { state: 'IL', county: 'Henry' },
    { state: 'IL', county: 'Iroquois' },
    { state: 'IL', county: 'Jackson' },
    { state: 'IL', county: 'Jasper' },
    { state: 'IL', county: 'Jefferson' },
    { state: 'IL', county: 'Jersey' },
    { state: 'IL', county: 'Jo Daviess' },
    { state: 'IL', county: 'Johnson' },
    { state: 'IL', county: 'Kane' },
    { state: 'IL', county: 'Kankakee' },
    { state: 'IL', county: 'Kendall' },
    { state: 'IL', county: 'Knox' },
    { state: 'IL', county: 'La Salle' },
    { state: 'IL', county: 'Lake' },
    { state: 'IL', county: 'Lawrence' },
    { state: 'IL', county: 'Lee' },
    { state: 'IL', county: 'Livingston' },
    { state: 'IL', county: 'Logan' },
    { state: 'IL', county: 'McDonough' },
    { state: 'IL', county: 'McHenry' },
    { state: 'IL', county: 'McLean' },
    { state: 'IL', county: 'Macon' },
    { state: 'IL', county: 'Macoupin' },
    { state: 'IL', county: 'Madison' },
    { state: 'IL', county: 'Marion' },
    { state: 'IL', county: 'Marshall' },
    { state: 'IL', county: 'Mason' },
    { state: 'IL', county: 'Massac' },
    { state: 'IL', county: 'Menard' },
    { state: 'IL', county: 'Mercer' },
    { state: 'IL', county: 'Monroe' },
    { state: 'IL', county: 'Montgomery' },
    { state: 'IL', county: 'Morgan' },
    { state: 'IL', county: 'Moultrie' },
    { state: 'IL', county: 'Ogle' },
    { state: 'IL', county: 'Peoria' },
    { state: 'IL', county: 'Perry' },
    { state: 'IL', county: 'Piatt' },
    { state: 'IL', county: 'Pike' },
    { state: 'IL', county: 'Pope' },
    { state: 'IL', county: 'Pulaski' },
    { state: 'IL', county: 'Putnam' },
    { state: 'IL', county: 'Randolph' },
    { state: 'IL', county: 'Richland' },
    { state: 'IL', county: 'Rock Island' },
    { state: 'IL', county: 'Saline' },
    { state: 'IL', county: 'Sangamon' },
    { state: 'IL', county: 'Schuyler' },
    { state: 'IL', county: 'Scott' },
    { state: 'IL', county: 'Shelby' },
    { state: 'IL', county: 'St. Clair' },
    { state: 'IL', county: 'Stark' },
    { state: 'IL', county: 'Stephenson' },
    { state: 'IL', county: 'Tazewell' },
    { state: 'IL', county: 'Union' },
    { state: 'IL', county: 'Vermilion' },
    { state: 'IL', county: 'Wabash' },
    { state: 'IL', county: 'Warren' },
    { state: 'IL', county: 'Washington' },
    { state: 'IL', county: 'Wayne' },
    { state: 'IL', county: 'White' },
    { state: 'IL', county: 'Whiteside' },
    { state: 'IL', county: 'Will' },
    { state: 'IL', county: 'Williamson' },
    { state: 'IL', county: 'Winnebago' },
    { state: 'IL', county: 'Woodford' },
    { state: 'IN', county: 'Adams' },
    { state: 'IN', county: 'Allen' },
    { state: 'IN', county: 'Bartholomew' },
    { state: 'IN', county: 'Benton' },
    { state: 'IN', county: 'Blackford' },
    { state: 'IN', county: 'Boone' },
    { state: 'IN', county: 'Brown' },
    { state: 'IN', county: 'Carroll' },
    { state: 'IN', county: 'Cass' },
    { state: 'IN', county: 'Clark' },
    { state: 'IN', county: 'Clay' },
    { state: 'IN', county: 'Clinton' },
    { state: 'IN', county: 'Crawford' },
    { state: 'IN', county: 'Daviess' },
    { state: 'IN', county: 'Dearborn' },
    { state: 'IN', county: 'Decatur' },
    { state: 'IN', county: 'De Kalb' },
    { state: 'IN', county: 'Delaware' },
    { state: 'IN', county: 'Dubois' },
    { state: 'IN', county: 'Elkhart' },
    { state: 'IN', county: 'Fayette' },
    { state: 'IN', county: 'Floyd' },
    { state: 'IN', county: 'Fountain' },
    { state: 'IN', county: 'Franklin' },
    { state: 'IN', county: 'Fulton' },
    { state: 'IN', county: 'Gibson' },
    { state: 'IN', county: 'Grant' },
    { state: 'IN', county: 'Greene' },
    { state: 'IN', county: 'Hamilton' },
    { state: 'IN', county: 'Hancock' },
    { state: 'IN', county: 'Harrison' },
    { state: 'IN', county: 'Hendricks' },
    { state: 'IN', county: 'Henry' },
    { state: 'IN', county: 'Howard' },
    { state: 'IN', county: 'Huntington' },
    { state: 'IN', county: 'Jackson' },
    { state: 'IN', county: 'Jasper' },
    { state: 'IN', county: 'Jay' },
    { state: 'IN', county: 'Jefferson' },
    { state: 'IN', county: 'Jennings' },
    { state: 'IN', county: 'Johnson' },
    { state: 'IN', county: 'Knox' },
    { state: 'IN', county: 'Kosciusko' },
    { state: 'IN', county: 'La Porte' },
    { state: 'IN', county: 'Lagrange' },
    { state: 'IN', county: 'Lake' },
    { state: 'IN', county: 'Lawrence' },
    { state: 'IN', county: 'Madison' },
    { state: 'IN', county: 'Marion' },
    { state: 'IN', county: 'Marshall' },
    { state: 'IN', county: 'Martin' },
    { state: 'IN', county: 'Miami' },
    { state: 'IN', county: 'Monroe' },
    { state: 'IN', county: 'Montgomery' },
    { state: 'IN', county: 'Morgan' },
    { state: 'IN', county: 'Newton' },
    { state: 'IN', county: 'Noble' },
    { state: 'IN', county: 'Ohio' },
    { state: 'IN', county: 'Orange' },
    { state: 'IN', county: 'Owen' },
    { state: 'IN', county: 'Parke' },
    { state: 'IN', county: 'Perry' },
    { state: 'IN', county: 'Pike' },
    { state: 'IN', county: 'Porter' },
    { state: 'IN', county: 'Posey' },
    { state: 'IN', county: 'Pulaski' },
    { state: 'IN', county: 'Putnam' },
    { state: 'IN', county: 'Randolph' },
    { state: 'IN', county: 'Ripley' },
    { state: 'IN', county: 'Rush' },
    { state: 'IN', county: 'St. Joseph' },
    { state: 'IN', county: 'Scott' },
    { state: 'IN', county: 'Shelby' },
    { state: 'IN', county: 'Spencer' },
    { state: 'IN', county: 'Starke' },
    { state: 'IN', county: 'Steuben' },
    { state: 'IN', county: 'Sullivan' },
    { state: 'IN', county: 'Switzerland' },
    { state: 'IN', county: 'Tippecanoe' },
    { state: 'IN', county: 'Tipton' },
    { state: 'IN', county: 'Union' },
    { state: 'IN', county: 'Vanderburgh' },
    { state: 'IN', county: 'Vermillion' },
    { state: 'IN', county: 'Vigo' },
    { state: 'IN', county: 'Wabash' },
    { state: 'IN', county: 'Warren' },
    { state: 'IN', county: 'Warrick' },
    { state: 'IN', county: 'Washington' },
    { state: 'IN', county: 'Wayne' },
    { state: 'IN', county: 'Wells' },
    { state: 'IN', county: 'White' },
    { state: 'IN', county: 'Whitley' },
    { state: 'IA', county: 'Adair' },
    { state: 'IA', county: 'Adams' },
    { state: 'IA', county: 'Allamakee' },
    { state: 'IA', county: 'Appanoose' },
    { state: 'IA', county: 'Audubon' },
    { state: 'IA', county: 'Benton' },
    { state: 'IA', county: 'Black Hawk' },
    { state: 'IA', county: 'Boone' },
    { state: 'IA', county: 'Bremer' },
    { state: 'IA', county: 'Buchanan' },
    { state: 'IA', county: 'Buena Vista' },
    { state: 'IA', county: 'Butler' },
    { state: 'IA', county: 'Calhoun' },
    { state: 'IA', county: 'Carroll' },
    { state: 'IA', county: 'Cass' },
    { state: 'IA', county: 'Cedar' },
    { state: 'IA', county: 'Cerro Gordo' },
    { state: 'IA', county: 'Cherokee' },
    { state: 'IA', county: 'Chickasaw' },
    { state: 'IA', county: 'Clarke' },
    { state: 'IA', county: 'Clay' },
    { state: 'IA', county: 'Clayton' },
    { state: 'IA', county: 'Clinton' },
    { state: 'IA', county: 'Crawford' },
    { state: 'IA', county: 'Dallas' },
    { state: 'IA', county: 'Davis' },
    { state: 'IA', county: 'Decatur' },
    { state: 'IA', county: 'Delaware' },
    { state: 'IA', county: 'Des Moines' },
    { state: 'IA', county: 'Dickinson' },
    { state: 'IA', county: 'Dubuque' },
    { state: 'IA', county: 'Emmet' },
    { state: 'IA', county: 'Fayette' },
    { state: 'IA', county: 'Floyd' },
    { state: 'IA', county: 'Franklin' },
    { state: 'IA', county: 'Fremont' },
    { state: 'IA', county: 'Greene' },
    { state: 'IA', county: 'Grundy' },
    { state: 'IA', county: 'Guthrie' },
    { state: 'IA', county: 'Hamilton' },
    { state: 'IA', county: 'Hancock' },
    { state: 'IA', county: 'Hardin' },
    { state: 'IA', county: 'Harrison' },
    { state: 'IA', county: 'Henry' },
    { state: 'IA', county: 'Howard' },
    { state: 'IA', county: 'Humboldt' },
    { state: 'IA', county: 'Ida' },
    { state: 'IA', county: 'Iowa' },
    { state: 'IA', county: 'Jackson' },
    { state: 'IA', county: 'Jasper' },
    { state: 'IA', county: 'Jefferson' },
    { state: 'IA', county: 'Johnson' },
    { state: 'IA', county: 'Jones' },
    { state: 'IA', county: 'Keokuk' },
    { state: 'IA', county: 'Kossuth' },
    { state: 'IA', county: 'Lee' },
    { state: 'IA', county: 'Linn' },
    { state: 'IA', county: 'Louisa' },
    { state: 'IA', county: 'Lucas' },
    { state: 'IA', county: 'Lyon' },
    { state: 'IA', county: 'Madison' },
    { state: 'IA', county: 'Mahaska' },
    { state: 'IA', county: 'Marion' },
    { state: 'IA', county: 'Marshall' },
    { state: 'IA', county: 'Mills' },
    { state: 'IA', county: 'Mitchell' },
    { state: 'IA', county: 'Monona' },
    { state: 'IA', county: 'Monroe' },
    { state: 'IA', county: 'Montgomery' },
    { state: 'IA', county: 'Muscatine' },
    { state: 'IA', county: "O'Brien" },
    { state: 'IA', county: 'Osceola' },
    { state: 'IA', county: 'Page' },
    { state: 'IA', county: 'Palo Alto' },
    { state: 'IA', county: 'Plymouth' },
    { state: 'IA', county: 'Pocahontas' },
    { state: 'IA', county: 'Polk' },
    { state: 'IA', county: 'Pottawattamie' },
    { state: 'IA', county: 'Poweshiek' },
    { state: 'IA', county: 'Ringgold' },
    { state: 'IA', county: 'Sac' },
    { state: 'IA', county: 'Scott' },
    { state: 'IA', county: 'Shelby' },
    { state: 'IA', county: 'Sioux' },
    { state: 'IA', county: 'Story' },
    { state: 'IA', county: 'Tama' },
    { state: 'IA', county: 'Taylor' },
    { state: 'IA', county: 'Union' },
    { state: 'IA', county: 'Van Buren' },
    { state: 'IA', county: 'Wapello' },
    { state: 'IA', county: 'Warren' },
    { state: 'IA', county: 'Washington' },
    { state: 'IA', county: 'Wayne' },
    { state: 'IA', county: 'Webster' },
    { state: 'IA', county: 'Winnebago' },
    { state: 'IA', county: 'Winneshiek' },
    { state: 'IA', county: 'Woodbury' },
    { state: 'IA', county: 'Worth' },
    { state: 'IA', county: 'Wright' },
    { state: 'KS', county: 'Allen' },
    { state: 'KS', county: 'Anderson' },
    { state: 'KS', county: 'Atchison' },
    { state: 'KS', county: 'Barber' },
    { state: 'KS', county: 'Barton' },
    { state: 'KS', county: 'Bourbon' },
    { state: 'KS', county: 'Brown' },
    { state: 'KS', county: 'Butler' },
    { state: 'KS', county: 'Chase' },
    { state: 'KS', county: 'Chautauqua' },
    { state: 'KS', county: 'Cherokee' },
    { state: 'KS', county: 'Cheyenne' },
    { state: 'KS', county: 'Clark' },
    { state: 'KS', county: 'Clay' },
    { state: 'KS', county: 'Cloud' },
    { state: 'KS', county: 'Coffey' },
    { state: 'KS', county: 'Comanche' },
    { state: 'KS', county: 'Cowley' },
    { state: 'KS', county: 'Crawford' },
    { state: 'KS', county: 'Decatur' },
    { state: 'KS', county: 'Dickinson' },
    { state: 'KS', county: 'Doniphan' },
    { state: 'KS', county: 'Douglas' },
    { state: 'KS', county: 'Edwards' },
    { state: 'KS', county: 'Elk' },
    { state: 'KS', county: 'Ellis' },
    { state: 'KS', county: 'Ellsworth' },
    { state: 'KS', county: 'Finney' },
    { state: 'KS', county: 'Ford' },
    { state: 'KS', county: 'Franklin' },
    { state: 'KS', county: 'Geary' },
    { state: 'KS', county: 'Gove' },
    { state: 'KS', county: 'Graham' },
    { state: 'KS', county: 'Grant' },
    { state: 'KS', county: 'Gray' },
    { state: 'KS', county: 'Greeley' },
    { state: 'KS', county: 'Greenwood' },
    { state: 'KS', county: 'Hamilton' },
    { state: 'KS', county: 'Harper' },
    { state: 'KS', county: 'Harvey' },
    { state: 'KS', county: 'Haskell' },
    { state: 'KS', county: 'Hodgeman' },
    { state: 'KS', county: 'Jackson' },
    { state: 'KS', county: 'Jefferson' },
    { state: 'KS', county: 'Jewell' },
    { state: 'KS', county: 'Johnson' },
    { state: 'KS', county: 'Kearny' },
    { state: 'KS', county: 'Kingman' },
    { state: 'KS', county: 'Kiowa' },
    { state: 'KS', county: 'Labette' },
    { state: 'KS', county: 'Lane' },
    { state: 'KS', county: 'Leavenworth' },
    { state: 'KS', county: 'Lincoln' },
    { state: 'KS', county: 'Linn' },
    { state: 'KS', county: 'Logan' },
    { state: 'KS', county: 'Lyon' },
    { state: 'KS', county: 'Marion' },
    { state: 'KS', county: 'Marshall' },
    { state: 'KS', county: 'McPherson' },
    { state: 'KS', county: 'Meade' },
    { state: 'KS', county: 'Miami' },
    { state: 'KS', county: 'Mitchell' },
    { state: 'KS', county: 'Montgomery' },
    { state: 'KS', county: 'Morris' },
    { state: 'KS', county: 'Morton' },
    { state: 'KS', county: 'Nemaha' },
    { state: 'KS', county: 'Neosho' },
    { state: 'KS', county: 'Ness' },
    { state: 'KS', county: 'Norton' },
    { state: 'KS', county: 'Osage' },
    { state: 'KS', county: 'Osborne' },
    { state: 'KS', county: 'Ottawa' },
    { state: 'KS', county: 'Pawnee' },
    { state: 'KS', county: 'Phillips' },
    { state: 'KS', county: 'Pottawatomie' },
    { state: 'KS', county: 'Pratt' },
    { state: 'KS', county: 'Rawlins' },
    { state: 'KS', county: 'Reno' },
    { state: 'KS', county: 'Republic' },
    { state: 'KS', county: 'Rice' },
    { state: 'KS', county: 'Riley' },
    { state: 'KS', county: 'Rooks' },
    { state: 'KS', county: 'Rush' },
    { state: 'KS', county: 'Russell' },
    { state: 'KS', county: 'Saline' },
    { state: 'KS', county: 'Scott' },
    { state: 'KS', county: 'Sedgwick' },
    { state: 'KS', county: 'Seward' },
    { state: 'KS', county: 'Shawnee' },
    { state: 'KS', county: 'Sheridan' },
    { state: 'KS', county: 'Sherman' },
    { state: 'KS', county: 'Smith' },
    { state: 'KS', county: 'Stafford' },
    { state: 'KS', county: 'Stanton' },
    { state: 'KS', county: 'Stevens' },
    { state: 'KS', county: 'Sumner' },
    { state: 'KS', county: 'Thomas' },
    { state: 'KS', county: 'Trego' },
    { state: 'KS', county: 'Wabaunsee' },
    { state: 'KS', county: 'Wallace' },
    { state: 'KS', county: 'Washington' },
    { state: 'KS', county: 'Wichita' },
    { state: 'KS', county: 'Wilson' },
    { state: 'KS', county: 'Woodson' },
    { state: 'KS', county: 'Wyandotte' },
    { state: 'KY', county: 'Adair' },
    { state: 'KY', county: 'Allen' },
    { state: 'KY', county: 'Anderson' },
    { state: 'KY', county: 'Ballard' },
    { state: 'KY', county: 'Barren' },
    { state: 'KY', county: 'Bath' },
    { state: 'KY', county: 'Bell' },
    { state: 'KY', county: 'Boone' },
    { state: 'KY', county: 'Bourbon' },
    { state: 'KY', county: 'Boyd' },
    { state: 'KY', county: 'Boyle' },
    { state: 'KY', county: 'Bracken' },
    { state: 'KY', county: 'Breathitt' },
    { state: 'KY', county: 'Breckinridge' },
    { state: 'KY', county: 'Bullitt' },
    { state: 'KY', county: 'Butler' },
    { state: 'KY', county: 'Caldwell' },
    { state: 'KY', county: 'Calloway' },
    { state: 'KY', county: 'Campbell' },
    { state: 'KY', county: 'Carlisle' },
    { state: 'KY', county: 'Carroll' },
    { state: 'KY', county: 'Carter' },
    { state: 'KY', county: 'Casey' },
    { state: 'KY', county: 'Christian' },
    { state: 'KY', county: 'Clark' },
    { state: 'KY', county: 'Clay' },
    { state: 'KY', county: 'Clinton' },
    { state: 'KY', county: 'Crittenden' },
    { state: 'KY', county: 'Cumberland' },
    { state: 'KY', county: 'Daviess' },
    { state: 'KY', county: 'Edmonson' },
    { state: 'KY', county: 'Elliott' },
    { state: 'KY', county: 'Estill' },
    { state: 'KY', county: 'Fayette' },
    { state: 'KY', county: 'Fleming' },
    { state: 'KY', county: 'Floyd' },
    { state: 'KY', county: 'Franklin' },
    { state: 'KY', county: 'Fulton' },
    { state: 'KY', county: 'Gallatin' },
    { state: 'KY', county: 'Garrard' },
    { state: 'KY', county: 'Grant' },
    { state: 'KY', county: 'Graves' },
    { state: 'KY', county: 'Grayson' },
    { state: 'KY', county: 'Green' },
    { state: 'KY', county: 'Greenup' },
    { state: 'KY', county: 'Hancock' },
    { state: 'KY', county: 'Hardin' },
    { state: 'KY', county: 'Harlan' },
    { state: 'KY', county: 'Harrison' },
    { state: 'KY', county: 'Hart' },
    { state: 'KY', county: 'Henderson' },
    { state: 'KY', county: 'Henry' },
    { state: 'KY', county: 'Hickman' },
    { state: 'KY', county: 'Hopkins' },
    { state: 'KY', county: 'Jackson' },
    { state: 'KY', county: 'Jefferson' },
    { state: 'KY', county: 'Jessamine' },
    { state: 'KY', county: 'Johnson' },
    { state: 'KY', county: 'Kenton' },
    { state: 'KY', county: 'Knott' },
    { state: 'KY', county: 'Knox' },
    { state: 'KY', county: 'LaRue' },
    { state: 'KY', county: 'Laurel' },
    { state: 'KY', county: 'Lawrence' },
    { state: 'KY', county: 'Lee' },
    { state: 'KY', county: 'Leslie' },
    { state: 'KY', county: 'Letcher' },
    { state: 'KY', county: 'Lewis' },
    { state: 'KY', county: 'Lincoln' },
    { state: 'KY', county: 'Livingston' },
    { state: 'KY', county: 'Logan' },
    { state: 'KY', county: 'Lyon' },
    { state: 'KY', county: 'McCracken' },
    { state: 'KY', county: 'McCreary' },
    { state: 'KY', county: 'McLean' },
    { state: 'KY', county: 'Madison' },
    { state: 'KY', county: 'Magoffin' },
    { state: 'KY', county: 'Marion' },
    { state: 'KY', county: 'Marshall' },
    { state: 'KY', county: 'Martin' },
    { state: 'KY', county: 'Mason' },
    { state: 'KY', county: 'Meade' },
    { state: 'KY', county: 'Menifee' },
    { state: 'KY', county: 'Mercer' },
    { state: 'KY', county: 'Metcalfe' },
    { state: 'KY', county: 'Monroe' },
    { state: 'KY', county: 'Montgomery' },
    { state: 'KY', county: 'Morgan' },
    { state: 'KY', county: 'Muhlenberg' },
    { state: 'KY', county: 'Nelson' },
    { state: 'KY', county: 'Nicholas' },
    { state: 'KY', county: 'Ohio' },
    { state: 'KY', county: 'Oldham' },
    { state: 'KY', county: 'Owen' },
    { state: 'KY', county: 'Owsley' },
    { state: 'KY', county: 'Pendleton' },
    { state: 'KY', county: 'Perry' },
    { state: 'KY', county: 'Pike' },
    { state: 'KY', county: 'Powell' },
    { state: 'KY', county: 'Pulaski' },
    { state: 'KY', county: 'Robertson' },
    { state: 'KY', county: 'Rockcastle' },
    { state: 'KY', county: 'Rowan' },
    { state: 'KY', county: 'Russell' },
    { state: 'KY', county: 'Scott' },
    { state: 'KY', county: 'Shelby' },
    { state: 'KY', county: 'Simpson' },
    { state: 'KY', county: 'Spencer' },
    { state: 'KY', county: 'Taylor' },
    { state: 'KY', county: 'Todd' },
    { state: 'KY', county: 'Trigg' },
    { state: 'KY', county: 'Trimble' },
    { state: 'KY', county: 'Union' },
    { state: 'KY', county: 'Warren' },
    { state: 'KY', county: 'Washington' },
    { state: 'KY', county: 'Wayne' },
    { state: 'KY', county: 'Webster' },
    { state: 'KY', county: 'Whitley' },
    { state: 'KY', county: 'Wolfe' },
    { state: 'KY', county: 'Woodford' },
    { state: 'LA', county: 'Acadia' },
    { state: 'LA', county: 'Allen' },
    { state: 'LA', county: 'Ascension' },
    { state: 'LA', county: 'Assumption' },
    { state: 'LA', county: 'Avoyelles' },
    { state: 'LA', county: 'Beauregard' },
    { state: 'LA', county: 'Bienville' },
    { state: 'LA', county: 'Bossier' },
    { state: 'LA', county: 'Caddo' },
    { state: 'LA', county: 'Calcasieu' },
    { state: 'LA', county: 'Caldwell' },
    { state: 'LA', county: 'Cameron' },
    { state: 'LA', county: 'Catahoula' },
    { state: 'LA', county: 'Claiborne' },
    { state: 'LA', county: 'Concordia' },
    { state: 'LA', county: 'De Soto' },
    { state: 'LA', county: 'East Baton Rouge' },
    { state: 'LA', county: 'East Carroll' },
    { state: 'LA', county: 'East Feliciana' },
    { state: 'LA', county: 'Evangeline' },
    { state: 'LA', county: 'Franklin' },
    { state: 'LA', county: 'Grant' },
    { state: 'LA', county: 'Iberia' },
    { state: 'LA', county: 'Iberville' },
    { state: 'LA', county: 'Jackson' },
    { state: 'LA', county: 'Jefferson' },
    { state: 'LA', county: 'Jefferson Davis' },
    { state: 'LA', county: 'La Salle' },
    { state: 'LA', county: 'Lafayette' },
    { state: 'LA', county: 'Lafourche' },
    { state: 'LA', county: 'Lincoln' },
    { state: 'LA', county: 'Livingston' },
    { state: 'LA', county: 'Madison' },
    { state: 'LA', county: 'Morehouse' },
    { state: 'LA', county: 'Natchitoches' },
    { state: 'LA', county: 'Orleans' },
    { state: 'LA', county: 'Ouachita' },
    { state: 'LA', county: 'Plaquemines' },
    { state: 'LA', county: 'Pointe Coupee' },
    { state: 'LA', county: 'Rapides' },
    { state: 'LA', county: 'Red River' },
    { state: 'LA', county: 'Richland' },
    { state: 'LA', county: 'Sabine' },
    { state: 'LA', county: 'St. Bernard' },
    { state: 'LA', county: 'St. Charles' },
    { state: 'LA', county: 'St. Helena' },
    { state: 'LA', county: 'St. James' },
    { state: 'LA', county: 'St. John The Baptist' },
    { state: 'LA', county: 'St. Landry' },
    { state: 'LA', county: 'St. Martin' },
    { state: 'LA', county: 'St. Mary' },
    { state: 'LA', county: 'St. Tammany' },
    { state: 'LA', county: 'Tangipahoa' },
    { state: 'LA', county: 'Tensas' },
    { state: 'LA', county: 'Terrebonne' },
    { state: 'LA', county: 'Union' },
    { state: 'LA', county: 'Vermilion' },
    { state: 'LA', county: 'Vernon' },
    { state: 'LA', county: 'Washington' },
    { state: 'LA', county: 'Webster' },
    { state: 'LA', county: 'West Baton Rouge' },
    { state: 'LA', county: 'West Carroll' },
    { state: 'LA', county: 'West Feliciana' },
    { state: 'LA', county: 'Winn' },
    { state: 'ME', county: 'Androscoggin' },
    { state: 'ME', county: 'Aroostook' },
    { state: 'ME', county: 'Cumberland' },
    { state: 'ME', county: 'Franklin' },
    { state: 'ME', county: 'Hancock' },
    { state: 'ME', county: 'Kennebec' },
    { state: 'ME', county: 'Knox' },
    { state: 'ME', county: 'Lincoln' },
    { state: 'ME', county: 'Oxford' },
    { state: 'ME', county: 'Penobscot' },
    { state: 'ME', county: 'Piscataquis' },
    { state: 'ME', county: 'Sagadahoc' },
    { state: 'ME', county: 'Somerset' },
    { state: 'ME', county: 'Waldo' },
    { state: 'ME', county: 'Washington' },
    { state: 'ME', county: 'York' },
    { state: 'MD', county: 'Allegany' },
    { state: 'MD', county: 'Anne Arundel' },
    { state: 'MD', county: 'Baltimore' },
    { state: 'MD', county: 'Baltimore City' },
    { state: 'MD', county: 'Calvert' },
    { state: 'MD', county: 'Caroline' },
    { state: 'MD', county: 'Carroll' },
    { state: 'MD', county: 'Cecil' },
    { state: 'MD', county: 'Charles' },
    { state: 'MD', county: 'Dorchester' },
    { state: 'MD', county: 'Frederick' },
    { state: 'MD', county: 'Garrett' },
    { state: 'MD', county: 'Harford' },
    { state: 'MD', county: 'Howard' },
    { state: 'MD', county: 'Kent' },
    { state: 'MD', county: 'Montgomery' },
    { state: 'MD', county: "Prince George's" },
    { state: 'MD', county: "Queen Anne's" },
    { state: 'MD', county: "St. Mary's" },
    { state: 'MD', county: 'Somerset' },
    { state: 'MD', county: 'Talbot' },
    { state: 'MD', county: 'Washington' },
    { state: 'MD', county: 'Wicomico' },
    { state: 'MD', county: 'Worcester' },
    { state: 'MA', county: 'Barnstable' },
    { state: 'MA', county: 'Berkshire' },
    { state: 'MA', county: 'Bristol' },
    { state: 'MA', county: 'Dukes' },
    { state: 'MA', county: 'Essex' },
    { state: 'MA', county: 'Franklin' },
    { state: 'MA', county: 'Hampden' },
    { state: 'MA', county: 'Hampshire' },
    { state: 'MA', county: 'Middlesex' },
    { state: 'MA', county: 'Nantucket' },
    { state: 'MA', county: 'Norfolk' },
    { state: 'MA', county: 'Plymouth' },
    { state: 'MA', county: 'Suffolk' },
    { state: 'MA', county: 'Worcester' },
    { state: 'MI', county: 'Alcona' },
    { state: 'MI', county: 'Alger' },
    { state: 'MI', county: 'Allegan' },
    { state: 'MI', county: 'Alpena' },
    { state: 'MI', county: 'Antrim' },
    { state: 'MI', county: 'Arenac' },
    { state: 'MI', county: 'Baraga' },
    { state: 'MI', county: 'Barry' },
    { state: 'MI', county: 'Bay' },
    { state: 'MI', county: 'Benzie' },
    { state: 'MI', county: 'Berrien' },
    { state: 'MI', county: 'Branch' },
    { state: 'MI', county: 'Calhoun' },
    { state: 'MI', county: 'Cass' },
    { state: 'MI', county: 'Charlevoix' },
    { state: 'MI', county: 'Cheboygan' },
    { state: 'MI', county: 'Chippewa' },
    { state: 'MI', county: 'Clare' },
    { state: 'MI', county: 'Clinton' },
    { state: 'MI', county: 'Crawford' },
    { state: 'MI', county: 'Delta' },
    { state: 'MI', county: 'Dickinson' },
    { state: 'MI', county: 'Eaton' },
    { state: 'MI', county: 'Emmet' },
    { state: 'MI', county: 'Genesee' },
    { state: 'MI', county: 'Gladwin' },
    { state: 'MI', county: 'Gogebic' },
    { state: 'MI', county: 'Grand Traverse' },
    { state: 'MI', county: 'Gratiot' },
    { state: 'MI', county: 'Hillsdale' },
    { state: 'MI', county: 'Houghton' },
    { state: 'MI', county: 'Huron' },
    { state: 'MI', county: 'Ingham' },
    { state: 'MI', county: 'Ionia' },
    { state: 'MI', county: 'Iosco' },
    { state: 'MI', county: 'Iron' },
    { state: 'MI', county: 'Isabella' },
    { state: 'MI', county: 'Jackson' },
    { state: 'MI', county: 'Kalamazoo' },
    { state: 'MI', county: 'Kalkaska' },
    { state: 'MI', county: 'Kent' },
    { state: 'MI', county: 'Keweenaw' },
    { state: 'MI', county: 'Lake' },
    { state: 'MI', county: 'Lapeer' },
    { state: 'MI', county: 'Leelanau' },
    { state: 'MI', county: 'Lenawee' },
    { state: 'MI', county: 'Livingston' },
    { state: 'MI', county: 'Luce' },
    { state: 'MI', county: 'Mackinac' },
    { state: 'MI', county: 'Macomb' },
    { state: 'MI', county: 'Manistee' },
    { state: 'MI', county: 'Marquette' },
    { state: 'MI', county: 'Mason' },
    { state: 'MI', county: 'Mecosta' },
    { state: 'MI', county: 'Menominee' },
    { state: 'MI', county: 'Midland' },
    { state: 'MI', county: 'Missaukee' },
    { state: 'MI', county: 'Monroe' },
    { state: 'MI', county: 'Montcalm' },
    { state: 'MI', county: 'Montmorency' },
    { state: 'MI', county: 'Muskegon' },
    { state: 'MI', county: 'Newaygo' },
    { state: 'MI', county: 'Oakland' },
    { state: 'MI', county: 'Oceana' },
    { state: 'MI', county: 'Ogemaw' },
    { state: 'MI', county: 'Ontonagon' },
    { state: 'MI', county: 'Osceola' },
    { state: 'MI', county: 'Oscoda' },
    { state: 'MI', county: 'Otsego' },
    { state: 'MI', county: 'Ottawa' },
    { state: 'MI', county: 'Presque Isle' },
    { state: 'MI', county: 'Roscommon' },
    { state: 'MI', county: 'Saginaw' },
    { state: 'MI', county: 'St. Clair' },
    { state: 'MI', county: 'St. Joseph' },
    { state: 'MI', county: 'Sanilac' },
    { state: 'MI', county: 'Schoolcraft' },
    { state: 'MI', county: 'Shiawassee' },
    { state: 'MI', county: 'Tuscola' },
    { state: 'MI', county: 'Van Buren' },
    { state: 'MI', county: 'Washtenaw' },
    { state: 'MI', county: 'Wayne' },
    { state: 'MI', county: 'Wexford' },
    { state: 'MN', county: 'Aitkin' },
    { state: 'MN', county: 'Anoka' },
    { state: 'MN', county: 'Becker' },
    { state: 'MN', county: 'Beltrami' },
    { state: 'MN', county: 'Benton' },
    { state: 'MN', county: 'Big Stone' },
    { state: 'MN', county: 'Blue Earth' },
    { state: 'MN', county: 'Brown' },
    { state: 'MN', county: 'Carlton' },
    { state: 'MN', county: 'Carver' },
    { state: 'MN', county: 'Cass' },
    { state: 'MN', county: 'Chippewa' },
    { state: 'MN', county: 'Chisago' },
    { state: 'MN', county: 'Clay' },
    { state: 'MN', county: 'Clearwater' },
    { state: 'MN', county: 'Cook' },
    { state: 'MN', county: 'Cottonwood' },
    { state: 'MN', county: 'Crow Wing' },
    { state: 'MN', county: 'Dakota' },
    { state: 'MN', county: 'Dodge' },
    { state: 'MN', county: 'Douglas' },
    { state: 'MN', county: 'Faribault' },
    { state: 'MN', county: 'Fillmore' },
    { state: 'MN', county: 'Freeborn' },
    { state: 'MN', county: 'Goodhue' },
    { state: 'MN', county: 'Grant' },
    { state: 'MN', county: 'Hennepin' },
    { state: 'MN', county: 'Houston' },
    { state: 'MN', county: 'Hubbard' },
    { state: 'MN', county: 'Isanti' },
    { state: 'MN', county: 'Itasca' },
    { state: 'MN', county: 'Jackson' },
    { state: 'MN', county: 'Kanabec' },
    { state: 'MN', county: 'Kandiyohi' },
    { state: 'MN', county: 'Kittson' },
    { state: 'MN', county: 'Koochiching' },
    { state: 'MN', county: 'Lac Qui Parle' },
    { state: 'MN', county: 'Lake' },
    { state: 'MN', county: 'Lake Of The Wood' },
    { state: 'MN', county: 'Le Sueur' },
    { state: 'MN', county: 'Lincoln' },
    { state: 'MN', county: 'Lyon' },
    { state: 'MN', county: 'Mahnomen' },
    { state: 'MN', county: 'Marshall' },
    { state: 'MN', county: 'Martin' },
    { state: 'MN', county: 'McLeod' },
    { state: 'MN', county: 'Meeker' },
    { state: 'MN', county: 'Mille Lacs' },
    { state: 'MN', county: 'Morrison' },
    { state: 'MN', county: 'Mower' },
    { state: 'MN', county: 'Murray' },
    { state: 'MN', county: 'Nicollet' },
    { state: 'MN', county: 'Nobles' },
    { state: 'MN', county: 'Norman' },
    { state: 'MN', county: 'Olmsted' },
    { state: 'MN', county: 'Otter Tail' },
    { state: 'MN', county: 'Pennington' },
    { state: 'MN', county: 'Pine' },
    { state: 'MN', county: 'Pipestone' },
    { state: 'MN', county: 'Polk' },
    { state: 'MN', county: 'Pope' },
    { state: 'MN', county: 'Ramsey' },
    { state: 'MN', county: 'Red Lake' },
    { state: 'MN', county: 'Redwood' },
    { state: 'MN', county: 'Renville' },
    { state: 'MN', county: 'Rice' },
    { state: 'MN', county: 'Rock' },
    { state: 'MN', county: 'Roseau' },
    { state: 'MN', county: 'St. Louis' },
    { state: 'MN', county: 'Scott' },
    { state: 'MN', county: 'Sherburne' },
    { state: 'MN', county: 'Sibley' },
    { state: 'MN', county: 'Stearns' },
    { state: 'MN', county: 'Steele' },
    { state: 'MN', county: 'Stevens' },
    { state: 'MN', county: 'Swift' },
    { state: 'MN', county: 'Todd' },
    { state: 'MN', county: 'Traverse' },
    { state: 'MN', county: 'Wabasha' },
    { state: 'MN', county: 'Wadena' },
    { state: 'MN', county: 'Waseca' },
    { state: 'MN', county: 'Washington' },
    { state: 'MN', county: 'Watonwan' },
    { state: 'MN', county: 'Wilkin' },
    { state: 'MN', county: 'Winona' },
    { state: 'MN', county: 'Wright' },
    { state: 'MN', county: 'Yellow Medicine' },
    { state: 'MS', county: 'Adams' },
    { state: 'MS', county: 'Alcorn' },
    { state: 'MS', county: 'Amite' },
    { state: 'MS', county: 'Attala' },
    { state: 'MS', county: 'Benton' },
    { state: 'MS', county: 'Bolivar' },
    { state: 'MS', county: 'Calhoun' },
    { state: 'MS', county: 'Carroll' },
    { state: 'MS', county: 'Chickasaw' },
    { state: 'MS', county: 'Choctaw' },
    { state: 'MS', county: 'Claiborne' },
    { state: 'MS', county: 'Clarke' },
    { state: 'MS', county: 'Clay' },
    { state: 'MS', county: 'Coahoma' },
    { state: 'MS', county: 'Copiah' },
    { state: 'MS', county: 'Covington' },
    { state: 'MS', county: 'De Soto' },
    { state: 'MS', county: 'Forrest' },
    { state: 'MS', county: 'Franklin' },
    { state: 'MS', county: 'George' },
    { state: 'MS', county: 'Greene' },
    { state: 'MS', county: 'Grenada' },
    { state: 'MS', county: 'Hancock' },
    { state: 'MS', county: 'Harrison' },
    { state: 'MS', county: 'Hinds' },
    { state: 'MS', county: 'Holmes' },
    { state: 'MS', county: 'Humphreys' },
    { state: 'MS', county: 'Issaquena' },
    { state: 'MS', county: 'Itawamba' },
    { state: 'MS', county: 'Jackson' },
    { state: 'MS', county: 'Jasper' },
    { state: 'MS', county: 'Jefferson' },
    { state: 'MS', county: 'Jefferson Davis' },
    { state: 'MS', county: 'Jones' },
    { state: 'MS', county: 'Kemper' },
    { state: 'MS', county: 'Lafayette' },
    { state: 'MS', county: 'Lamar' },
    { state: 'MS', county: 'Lauderdale' },
    { state: 'MS', county: 'Lawrence' },
    { state: 'MS', county: 'Leake' },
    { state: 'MS', county: 'Lee' },
    { state: 'MS', county: 'Leflore' },
    { state: 'MS', county: 'Lincoln' },
    { state: 'MS', county: 'Lowndes' },
    { state: 'MS', county: 'Madison' },
    { state: 'MS', county: 'Marion' },
    { state: 'MS', county: 'Marshall' },
    { state: 'MS', county: 'Monroe' },
    { state: 'MS', county: 'Montgomery' },
    { state: 'MS', county: 'Neshoba' },
    { state: 'MS', county: 'Newton' },
    { state: 'MS', county: 'Noxubee' },
    { state: 'MS', county: 'Oktibbeha' },
    { state: 'MS', county: 'Panola' },
    { state: 'MS', county: 'Pearl River' },
    { state: 'MS', county: 'Perry' },
    { state: 'MS', county: 'Pike' },
    { state: 'MS', county: 'Pontotoc' },
    { state: 'MS', county: 'Prentiss' },
    { state: 'MS', county: 'Quitman' },
    { state: 'MS', county: 'Rankin' },
    { state: 'MS', county: 'Scott' },
    { state: 'MS', county: 'Sharkey' },
    { state: 'MS', county: 'Simpson' },
    { state: 'MS', county: 'Smith' },
    { state: 'MS', county: 'Stone' },
    { state: 'MS', county: 'Sunflower' },
    { state: 'MS', county: 'Tallahatchie' },
    { state: 'MS', county: 'Tate' },
    { state: 'MS', county: 'Tippah' },
    { state: 'MS', county: 'Tishomingo' },
    { state: 'MS', county: 'Tunica' },
    { state: 'MS', county: 'Union' },
    { state: 'MS', county: 'Walthall' },
    { state: 'MS', county: 'Warren' },
    { state: 'MS', county: 'Washington' },
    { state: 'MS', county: 'Wayne' },
    { state: 'MS', county: 'Webster' },
    { state: 'MS', county: 'Wilkinson' },
    { state: 'MS', county: 'Winston' },
    { state: 'MS', county: 'Yalobusha' },
    { state: 'MS', county: 'Yazoo' },
    { state: 'MO', county: 'Adair' },
    { state: 'MO', county: 'Andrew' },
    { state: 'MO', county: 'Atchison' },
    { state: 'MO', county: 'Audrain' },
    { state: 'MO', county: 'Barry' },
    { state: 'MO', county: 'Barton' },
    { state: 'MO', county: 'Bates' },
    { state: 'MO', county: 'Benton' },
    { state: 'MO', county: 'Bollinger' },
    { state: 'MO', county: 'Boone' },
    { state: 'MO', county: 'Buchanan' },
    { state: 'MO', county: 'Butler' },
    { state: 'MO', county: 'Caldwell' },
    { state: 'MO', county: 'Callaway' },
    { state: 'MO', county: 'Camden' },
    { state: 'MO', county: 'Cape Girardeau' },
    { state: 'MO', county: 'Carroll' },
    { state: 'MO', county: 'Carter' },
    { state: 'MO', county: 'Cass' },
    { state: 'MO', county: 'Cedar' },
    { state: 'MO', county: 'Chariton' },
    { state: 'MO', county: 'Christian' },
    { state: 'MO', county: 'Clark' },
    { state: 'MO', county: 'Clay' },
    { state: 'MO', county: 'Clinton' },
    { state: 'MO', county: 'Cole' },
    { state: 'MO', county: 'Cooper' },
    { state: 'MO', county: 'Crawford' },
    { state: 'MO', county: 'Dade' },
    { state: 'MO', county: 'Dallas' },
    { state: 'MO', county: 'Daviess' },
    { state: 'MO', county: 'De Kalb' },
    { state: 'MO', county: 'Dent' },
    { state: 'MO', county: 'Douglas' },
    { state: 'MO', county: 'Dunklin' },
    { state: 'MO', county: 'Franklin' },
    { state: 'MO', county: 'Gasconade' },
    { state: 'MO', county: 'Gentry' },
    { state: 'MO', county: 'Greene' },
    { state: 'MO', county: 'Grundy' },
    { state: 'MO', county: 'Harrison' },
    { state: 'MO', county: 'Henry' },
    { state: 'MO', county: 'Hickory' },
    { state: 'MO', county: 'Holt' },
    { state: 'MO', county: 'Howard' },
    { state: 'MO', county: 'Howell' },
    { state: 'MO', county: 'Iron' },
    { state: 'MO', county: 'Jackson' },
    { state: 'MO', county: 'Jasper' },
    { state: 'MO', county: 'Jefferson' },
    { state: 'MO', county: 'Johnson' },
    { state: 'MO', county: 'Knox' },
    { state: 'MO', county: 'Laclede' },
    { state: 'MO', county: 'Lafayette' },
    { state: 'MO', county: 'Lawrence' },
    { state: 'MO', county: 'Lewis' },
    { state: 'MO', county: 'Lincoln' },
    { state: 'MO', county: 'Linn' },
    { state: 'MO', county: 'Livingston' },
    { state: 'MO', county: 'Macon' },
    { state: 'MO', county: 'Madison' },
    { state: 'MO', county: 'Maries' },
    { state: 'MO', county: 'Marion' },
    { state: 'MO', county: 'McDonald' },
    { state: 'MO', county: 'Mercer' },
    { state: 'MO', county: 'Miller' },
    { state: 'MO', county: 'Missippi' },
    { state: 'MO', county: 'Moniteau' },
    { state: 'MO', county: 'Monroe' },
    { state: 'MO', county: 'Montgomery' },
    { state: 'MO', county: 'Morgan' },
    { state: 'MO', county: 'New Madrid' },
    { state: 'MO', county: 'Newton' },
    { state: 'MO', county: 'Nodaway' },
    { state: 'MO', county: 'Oregon' },
    { state: 'MO', county: 'Osage' },
    { state: 'MO', county: 'Ozark' },
    { state: 'MO', county: 'Pemiscot' },
    { state: 'MO', county: 'Perry' },
    { state: 'MO', county: 'Pettis' },
    { state: 'MO', county: 'Phelps' },
    { state: 'MO', county: 'Pike' },
    { state: 'MO', county: 'Platte' },
    { state: 'MO', county: 'Polk' },
    { state: 'MO', county: 'Pulaski' },
    { state: 'MO', county: 'Putnam' },
    { state: 'MO', county: 'Ralls' },
    { state: 'MO', county: 'Randolph' },
    { state: 'MO', county: 'Ray' },
    { state: 'MO', county: 'Reynolds' },
    { state: 'MO', county: 'Ripley' },
    { state: 'MO', county: 'St. Charles' },
    { state: 'MO', county: 'St. Clair' },
    { state: 'MO', county: 'Ste. Genevieve' },
    { state: 'MO', county: 'St. Francois' },
    { state: 'MO', county: 'St. Louis' },
    { state: 'MO', county: 'St. Louis City' },
    { state: 'MO', county: 'Saline' },
    { state: 'MO', county: 'Schuyler' },
    { state: 'MO', county: 'Scotland' },
    { state: 'MO', county: 'Scott' },
    { state: 'MO', county: 'Shannon' },
    { state: 'MO', county: 'Shelby' },
    { state: 'MO', county: 'Stoddard' },
    { state: 'MO', county: 'Stone' },
    { state: 'MO', county: 'Sullivan' },
    { state: 'MO', county: 'Taney' },
    { state: 'MO', county: 'Texas' },
    { state: 'MO', county: 'Vernon' },
    { state: 'MO', county: 'Warren' },
    { state: 'MO', county: 'Washington' },
    { state: 'MO', county: 'Wayne' },
    { state: 'MO', county: 'Webster' },
    { state: 'MO', county: 'Worth' },
    { state: 'MO', county: 'Wright' },
    { state: 'MT', county: 'Beaverhead' },
    { state: 'MT', county: 'Big Horn' },
    { state: 'MT', county: 'Blaine' },
    { state: 'MT', county: 'Broadwater' },
    { state: 'MT', county: 'Carbon' },
    { state: 'MT', county: 'Carter' },
    { state: 'MT', county: 'Cascade' },
    { state: 'MT', county: 'Chouteau' },
    { state: 'MT', county: 'Custer' },
    { state: 'MT', county: 'Daniels' },
    { state: 'MT', county: 'Dawson' },
    { state: 'MT', county: 'Deer Lodge' },
    { state: 'MT', county: 'Fallon' },
    { state: 'MT', county: 'Fergus' },
    { state: 'MT', county: 'Flathead' },
    { state: 'MT', county: 'Gallatin' },
    { state: 'MT', county: 'Garfield' },
    { state: 'MT', county: 'Glacier' },
    { state: 'MT', county: 'Golden Valley' },
    { state: 'MT', county: 'Granite' },
    { state: 'MT', county: 'Hill' },
    { state: 'MT', county: 'Jefferson' },
    { state: 'MT', county: 'Judith Basin' },
    { state: 'MT', county: 'Lake' },
    { state: 'MT', county: 'Lewis And Clark' },
    { state: 'MT', county: 'Liberty' },
    { state: 'MT', county: 'Lincoln' },
    { state: 'MT', county: 'Madison' },
    { state: 'MT', county: 'McCone' },
    { state: 'MT', county: 'Meagher' },
    { state: 'MT', county: 'Mineral' },
    { state: 'MT', county: 'Missoula' },
    { state: 'MT', county: 'Musselshell' },
    { state: 'MT', county: 'Park' },
    { state: 'MT', county: 'Petroleum' },
    { state: 'MT', county: 'Phillips' },
    { state: 'MT', county: 'Pondera' },
    { state: 'MT', county: 'Powder River' },
    { state: 'MT', county: 'Powell' },
    { state: 'MT', county: 'Prairie' },
    { state: 'MT', county: 'Ravalli' },
    { state: 'MT', county: 'Richland' },
    { state: 'MT', county: 'Roosevelt' },
    { state: 'MT', county: 'Rosebud' },
    { state: 'MT', county: 'Sanders' },
    { state: 'MT', county: 'Sheridan' },
    { state: 'MT', county: 'Silver Bow' },
    { state: 'MT', county: 'Stillwater' },
    { state: 'MT', county: 'Sweet Grass' },
    { state: 'MT', county: 'Teton' },
    { state: 'MT', county: 'Toole' },
    { state: 'MT', county: 'Treasure' },
    { state: 'MT', county: 'Valley' },
    { state: 'MT', county: 'Wheatland' },
    { state: 'MT', county: 'Wibaux' },
    { state: 'MT', county: 'Yellowstone' },
    { state: 'NE', county: 'Adams' },
    { state: 'NE', county: 'Antelope' },
    { state: 'NE', county: 'Arthur' },
    { state: 'NE', county: 'Banner' },
    { state: 'NE', county: 'Blaine' },
    { state: 'NE', county: 'Boone' },
    { state: 'NE', county: 'Box Butte' },
    { state: 'NE', county: 'Boyd' },
    { state: 'NE', county: 'Brown' },
    { state: 'NE', county: 'Buffalo' },
    { state: 'NE', county: 'Burt' },
    { state: 'NE', county: 'Butler' },
    { state: 'NE', county: 'Cass' },
    { state: 'NE', county: 'Cedar' },
    { state: 'NE', county: 'Chase' },
    { state: 'NE', county: 'Cherry' },
    { state: 'NE', county: 'Cheyenne' },
    { state: 'NE', county: 'Clay' },
    { state: 'NE', county: 'Colfax' },
    { state: 'NE', county: 'Cuming' },
    { state: 'NE', county: 'Custer' },
    { state: 'NE', county: 'Dakota' },
    { state: 'NE', county: 'Dawes' },
    { state: 'NE', county: 'Dawson' },
    { state: 'NE', county: 'Deuel' },
    { state: 'NE', county: 'Dixon' },
    { state: 'NE', county: 'Dodge' },
    { state: 'NE', county: 'Douglas' },
    { state: 'NE', county: 'Dundy' },
    { state: 'NE', county: 'Fillmore' },
    { state: 'NE', county: 'Franklin' },
    { state: 'NE', county: 'Frontier' },
    { state: 'NE', county: 'Furnas' },
    { state: 'NE', county: 'Gage' },
    { state: 'NE', county: 'Garden' },
    { state: 'NE', county: 'Garfield' },
    { state: 'NE', county: 'Gosper' },
    { state: 'NE', county: 'Grant' },
    { state: 'NE', county: 'Greeley' },
    { state: 'NE', county: 'Hall' },
    { state: 'NE', county: 'Hamilton' },
    { state: 'NE', county: 'Harlan' },
    { state: 'NE', county: 'Hayes' },
    { state: 'NE', county: 'Hitchcock' },
    { state: 'NE', county: 'Holt' },
    { state: 'NE', county: 'Hooker' },
    { state: 'NE', county: 'Howard' },
    { state: 'NE', county: 'Jefferson' },
    { state: 'NE', county: 'Johnson' },
    { state: 'NE', county: 'Kearney' },
    { state: 'NE', county: 'Keith' },
    { state: 'NE', county: 'Keya Paha' },
    { state: 'NE', county: 'Kimball' },
    { state: 'NE', county: 'Knox' },
    { state: 'NE', county: 'Lancaster' },
    { state: 'NE', county: 'Lincoln' },
    { state: 'NE', county: 'Logan' },
    { state: 'NE', county: 'Loup' },
    { state: 'NE', county: 'McPherson' },
    { state: 'NE', county: 'Madison' },
    { state: 'NE', county: 'Merrick' },
    { state: 'NE', county: 'Morrill' },
    { state: 'NE', county: 'Nance' },
    { state: 'NE', county: 'Nemaha' },
    { state: 'NE', county: 'Nuckolls' },
    { state: 'NE', county: 'Otoe' },
    { state: 'NE', county: 'Pawnee' },
    { state: 'NE', county: 'Perkins' },
    { state: 'NE', county: 'Phelps' },
    { state: 'NE', county: 'Pierce' },
    { state: 'NE', county: 'Platte' },
    { state: 'NE', county: 'Polk' },
    { state: 'NE', county: 'Red Willow' },
    { state: 'NE', county: 'Richardson' },
    { state: 'NE', county: 'Rock' },
    { state: 'NE', county: 'Saline' },
    { state: 'NE', county: 'Sarpy' },
    { state: 'NE', county: 'Saunders' },
    { state: 'NE', county: 'Scotts Bluff' },
    { state: 'NE', county: 'Seward' },
    { state: 'NE', county: 'Sheridan' },
    { state: 'NE', county: 'Sherman' },
    { state: 'NE', county: 'Sioux' },
    { state: 'NE', county: 'Stanton' },
    { state: 'NE', county: 'Thayer' },
    { state: 'NE', county: 'Thomas' },
    { state: 'NE', county: 'Thurston' },
    { state: 'NE', county: 'Valley' },
    { state: 'NE', county: 'Washington' },
    { state: 'NE', county: 'Wayne' },
    { state: 'NE', county: 'Webster' },
    { state: 'NE', county: 'Wheeler' },
    { state: 'NE', county: 'York' },
    { state: 'NV', county: 'Carson City' },
    { state: 'NV', county: 'Churchill' },
    { state: 'NV', county: 'Clark' },
    { state: 'NV', county: 'Douglas' },
    { state: 'NV', county: 'Elko' },
    { state: 'NV', county: 'Esmeralda' },
    { state: 'NV', county: 'Eureka' },
    { state: 'NV', county: 'Humboldt' },
    { state: 'NV', county: 'Lander' },
    { state: 'NV', county: 'Lincoln' },
    { state: 'NV', county: 'Lyon' },
    { state: 'NV', county: 'Mineral' },
    { state: 'NV', county: 'Nye' },
    { state: 'NV', county: 'Pershing' },
    { state: 'NV', county: 'Storey' },
    { state: 'NV', county: 'Washoe' },
    { state: 'NV', county: 'White Pine' },
    { state: 'NH', county: 'Belknap' },
    { state: 'NH', county: 'Carroll' },
    { state: 'NH', county: 'Cheshire' },
    { state: 'NH', county: 'Coos' },
    { state: 'NH', county: 'Grafton' },
    { state: 'NH', county: 'Hillsborough' },
    { state: 'NH', county: 'Merrimack' },
    { state: 'NH', county: 'Rockingham' },
    { state: 'NH', county: 'Strafford' },
    { state: 'NH', county: 'Sullivan' },
    { state: 'NJ', county: 'Atlantic' },
    { state: 'NJ', county: 'Bergen' },
    { state: 'NJ', county: 'Burlington' },
    { state: 'NJ', county: 'Camden' },
    { state: 'NJ', county: 'Cape May' },
    { state: 'NJ', county: 'Cumberland' },
    { state: 'NJ', county: 'Essex' },
    { state: 'NJ', county: 'Gloucester' },
    { state: 'NJ', county: 'Hudson' },
    { state: 'NJ', county: 'Hunterdon' },
    { state: 'NJ', county: 'Mercer' },
    { state: 'NJ', county: 'Middlesex' },
    { state: 'NJ', county: 'Monmouth' },
    { state: 'NJ', county: 'Morris' },
    { state: 'NJ', county: 'Ocean' },
    { state: 'NJ', county: 'Passaic' },
    { state: 'NJ', county: 'Salem' },
    { state: 'NJ', county: 'Somerset' },
    { state: 'NJ', county: 'Sussex' },
    { state: 'NJ', county: 'Union' },
    { state: 'NJ', county: 'Warren' },
    { state: 'NM', county: 'Bernalillo' },
    { state: 'NM', county: 'Catron' },
    { state: 'NM', county: 'Chaves' },
    { state: 'NM', county: 'Cibola' },
    { state: 'NM', county: 'Colfax' },
    { state: 'NM', county: 'Curry' },
    { state: 'NM', county: 'De Baca' },
    { state: 'NM', county: 'Dona Ana' },
    { state: 'NM', county: 'Eddy' },
    { state: 'NM', county: 'Grant' },
    { state: 'NM', county: 'Guadalupe' },
    { state: 'NM', county: 'Harding' },
    { state: 'NM', county: 'Hidalgo' },
    { state: 'NM', county: 'Lea' },
    { state: 'NM', county: 'Lincoln' },
    { state: 'NM', county: 'Los Alamos' },
    { state: 'NM', county: 'Luna' },
    { state: 'NM', county: 'McKinley' },
    { state: 'NM', county: 'Mora' },
    { state: 'NM', county: 'Otero' },
    { state: 'NM', county: 'Quay' },
    { state: 'NM', county: 'Rio Arriba' },
    { state: 'NM', county: 'Roosevelt' },
    { state: 'NM', county: 'Sandoval' },
    { state: 'NM', county: 'San Juan' },
    { state: 'NM', county: 'San Miguel' },
    { state: 'NM', county: 'Santa Fe' },
    { state: 'NM', county: 'Sierra' },
    { state: 'NM', county: 'Socorro' },
    { state: 'NM', county: 'Taos' },
    { state: 'NM', county: 'Torrance' },
    { state: 'NM', county: 'Union' },
    { state: 'NM', county: 'Valencia' },
    { state: 'NY', county: 'Albany' },
    { state: 'NY', county: 'Allegany' },
    { state: 'NY', county: 'Bronx' },
    { state: 'NY', county: 'Broome' },
    { state: 'NY', county: 'Cattaraugus' },
    { state: 'NY', county: 'Cayuga' },
    { state: 'NY', county: 'Chautauqua' },
    { state: 'NY', county: 'Chemung' },
    { state: 'NY', county: 'Chenango' },
    { state: 'NY', county: 'Clinton' },
    { state: 'NY', county: 'Columbia' },
    { state: 'NY', county: 'Cortland' },
    { state: 'NY', county: 'Delaware' },
    { state: 'NY', county: 'Dutchess' },
    { state: 'NY', county: 'Erie' },
    { state: 'NY', county: 'Essex' },
    { state: 'NY', county: 'Franklin' },
    { state: 'NY', county: 'Fulton' },
    { state: 'NY', county: 'Genesee' },
    { state: 'NY', county: 'Greene' },
    { state: 'NY', county: 'Hamilton' },
    { state: 'NY', county: 'Herkimer' },
    { state: 'NY', county: 'Jefferson' },
    { state: 'NY', county: 'Kings' },
    { state: 'NY', county: 'Lewis' },
    { state: 'NY', county: 'Livingston' },
    { state: 'NY', county: 'Madison' },
    { state: 'NY', county: 'Monroe' },
    { state: 'NY', county: 'Montgomery' },
    { state: 'NY', county: 'Nassau' },
    { state: 'NY', county: 'New York City' },
    { state: 'NY', county: 'Niagara' },
    { state: 'NY', county: 'Oneida' },
    { state: 'NY', county: 'Onondaga' },
    { state: 'NY', county: 'Ontario' },
    { state: 'NY', county: 'Orange' },
    { state: 'NY', county: 'Orleans' },
    { state: 'NY', county: 'Oswego' },
    { state: 'NY', county: 'Otsego' },
    { state: 'NY', county: 'Putnam' },
    { state: 'NY', county: 'Queens' },
    { state: 'NY', county: 'Rensselaer' },
    { state: 'NY', county: 'Richmond' },
    { state: 'NY', county: 'Rockland' },
    { state: 'NY', county: 'St. Lawrence' },
    { state: 'NY', county: 'Saratoga' },
    { state: 'NY', county: 'Schenectady' },
    { state: 'NY', county: 'Schoharie' },
    { state: 'NY', county: 'Schuyler' },
    { state: 'NY', county: 'Seneca' },
    { state: 'NY', county: 'Steuben' },
    { state: 'NY', county: 'Suffolk' },
    { state: 'NY', county: 'Sullivan' },
    { state: 'NY', county: 'Tioga' },
    { state: 'NY', county: 'Tompkins' },
    { state: 'NY', county: 'Ulster' },
    { state: 'NY', county: 'Warren' },
    { state: 'NY', county: 'Washington' },
    { state: 'NY', county: 'Wayne' },
    { state: 'NY', county: 'Westchester' },
    { state: 'NY', county: 'Wyoming' },
    { state: 'NY', county: 'Yates' },
    { state: 'NC', county: 'Alamance' },
    { state: 'NC', county: 'Alexander' },
    { state: 'NC', county: 'Alleghany' },
    { state: 'NC', county: 'Anson' },
    { state: 'NC', county: 'Ashe' },
    { state: 'NC', county: 'Avery' },
    { state: 'NC', county: 'Beaufort' },
    { state: 'NC', county: 'Bertie' },
    { state: 'NC', county: 'Bladen' },
    { state: 'NC', county: 'Brunswick' },
    { state: 'NC', county: 'Buncombe' },
    { state: 'NC', county: 'Burke' },
    { state: 'NC', county: 'Cabarrus' },
    { state: 'NC', county: 'Caldwell' },
    { state: 'NC', county: 'Camden' },
    { state: 'NC', county: 'Carteret' },
    { state: 'NC', county: 'Caswell' },
    { state: 'NC', county: 'Catawba' },
    { state: 'NC', county: 'Chatham' },
    { state: 'NC', county: 'Cherokee' },
    { state: 'NC', county: 'Chowan' },
    { state: 'NC', county: 'Clay' },
    { state: 'NC', county: 'Cleveland' },
    { state: 'NC', county: 'Columbus' },
    { state: 'NC', county: 'Craven' },
    { state: 'NC', county: 'Cumberland' },
    { state: 'NC', county: 'Currituck' },
    { state: 'NC', county: 'Dare' },
    { state: 'NC', county: 'Davidson' },
    { state: 'NC', county: 'Davie' },
    { state: 'NC', county: 'Duplin' },
    { state: 'NC', county: 'Durham' },
    { state: 'NC', county: 'Edgecombe' },
    { state: 'NC', county: 'Forsyth' },
    { state: 'NC', county: 'Franklin' },
    { state: 'NC', county: 'Gaston' },
    { state: 'NC', county: 'Gates' },
    { state: 'NC', county: 'Graham' },
    { state: 'NC', county: 'Granville' },
    { state: 'NC', county: 'Greene' },
    { state: 'NC', county: 'Guilford' },
    { state: 'NC', county: 'Halifax' },
    { state: 'NC', county: 'Harnett' },
    { state: 'NC', county: 'Haywood' },
    { state: 'NC', county: 'Henderson' },
    { state: 'NC', county: 'Hertford' },
    { state: 'NC', county: 'Hoke' },
    { state: 'NC', county: 'Hyde' },
    { state: 'NC', county: 'Iredell' },
    { state: 'NC', county: 'Jackson' },
    { state: 'NC', county: 'Johnston' },
    { state: 'NC', county: 'Jones' },
    { state: 'NC', county: 'Lee' },
    { state: 'NC', county: 'Lenoir' },
    { state: 'NC', county: 'Lincoln' },
    { state: 'NC', county: 'McDowell' },
    { state: 'NC', county: 'Macon' },
    { state: 'NC', county: 'Madison' },
    { state: 'NC', county: 'Martin' },
    { state: 'NC', county: 'Mecklenburg' },
    { state: 'NC', county: 'Mitchell' },
    { state: 'NC', county: 'Montgomery' },
    { state: 'NC', county: 'Moore' },
    { state: 'NC', county: 'Nash' },
    { state: 'NC', county: 'New Hanover' },
    { state: 'NC', county: 'Northampton' },
    { state: 'NC', county: 'Onslow' },
    { state: 'NC', county: 'Orange' },
    { state: 'NC', county: 'Pamlico' },
    { state: 'NC', county: 'Pasquotank' },
    { state: 'NC', county: 'Pender' },
    { state: 'NC', county: 'Perquimans' },
    { state: 'NC', county: 'Person' },
    { state: 'NC', county: 'Pitt' },
    { state: 'NC', county: 'Polk' },
    { state: 'NC', county: 'Randolph' },
    { state: 'NC', county: 'Richmond' },
    { state: 'NC', county: 'Robeson' },
    { state: 'NC', county: 'Rockingham' },
    { state: 'NC', county: 'Rowan' },
    { state: 'NC', county: 'Rutherford' },
    { state: 'NC', county: 'Sampson' },
    { state: 'NC', county: 'Scotland' },
    { state: 'NC', county: 'Stanly' },
    { state: 'NC', county: 'Stokes' },
    { state: 'NC', county: 'Surry' },
    { state: 'NC', county: 'Swain' },
    { state: 'NC', county: 'Transylvania' },
    { state: 'NC', county: 'Tyrrell' },
    { state: 'NC', county: 'Union' },
    { state: 'NC', county: 'Vance' },
    { state: 'NC', county: 'Wake' },
    { state: 'NC', county: 'Warren' },
    { state: 'NC', county: 'Washington' },
    { state: 'NC', county: 'Watauga' },
    { state: 'NC', county: 'Wayne' },
    { state: 'NC', county: 'Wilkes' },
    { state: 'NC', county: 'Wilson' },
    { state: 'NC', county: 'Yadkin' },
    { state: 'NC', county: 'Yancey' },
    { state: 'ND', county: 'Adams' },
    { state: 'ND', county: 'Barnes' },
    { state: 'ND', county: 'Benson' },
    { state: 'ND', county: 'Billings' },
    { state: 'ND', county: 'Bottineau' },
    { state: 'ND', county: 'Bowman' },
    { state: 'ND', county: 'Burke' },
    { state: 'ND', county: 'Burleigh' },
    { state: 'ND', county: 'Cass' },
    { state: 'ND', county: 'Cavalier' },
    { state: 'ND', county: 'Dickey' },
    { state: 'ND', county: 'Divide' },
    { state: 'ND', county: 'Dunn' },
    { state: 'ND', county: 'Eddy' },
    { state: 'ND', county: 'Emmons' },
    { state: 'ND', county: 'Foster' },
    { state: 'ND', county: 'Golden Valley' },
    { state: 'ND', county: 'Grand Forks' },
    { state: 'ND', county: 'Grant' },
    { state: 'ND', county: 'Griggs' },
    { state: 'ND', county: 'Hettinger' },
    { state: 'ND', county: 'Kidder' },
    { state: 'ND', county: 'LaMoure' },
    { state: 'ND', county: 'Logan' },
    { state: 'ND', county: 'McHenry' },
    { state: 'ND', county: 'McIntosh' },
    { state: 'ND', county: 'McKenzie' },
    { state: 'ND', county: 'McLean' },
    { state: 'ND', county: 'Mercer' },
    { state: 'ND', county: 'Morton' },
    { state: 'ND', county: 'Mountrail' },
    { state: 'ND', county: 'Nelson' },
    { state: 'ND', county: 'Oliver' },
    { state: 'ND', county: 'Pembina' },
    { state: 'ND', county: 'Pierce' },
    { state: 'ND', county: 'Ramsey' },
    { state: 'ND', county: 'Ransom' },
    { state: 'ND', county: 'Renville' },
    { state: 'ND', county: 'Richland' },
    { state: 'ND', county: 'Rolette' },
    { state: 'ND', county: 'Sargent' },
    { state: 'ND', county: 'Sheridan' },
    { state: 'ND', county: 'Sioux' },
    { state: 'ND', county: 'Slope' },
    { state: 'ND', county: 'Stark' },
    { state: 'ND', county: 'Steele' },
    { state: 'ND', county: 'Stutsman' },
    { state: 'ND', county: 'Towner' },
    { state: 'ND', county: 'Traill' },
    { state: 'ND', county: 'Walsh' },
    { state: 'ND', county: 'Ward' },
    { state: 'ND', county: 'Wells' },
    { state: 'ND', county: 'Williams' },
    { state: 'OH', county: 'Adams' },
    { state: 'OH', county: 'Allen' },
    { state: 'OH', county: 'Ashland' },
    { state: 'OH', county: 'Ashtabula' },
    { state: 'OH', county: 'Athens' },
    { state: 'OH', county: 'Auglaize' },
    { state: 'OH', county: 'Belmont' },
    { state: 'OH', county: 'Brown' },
    { state: 'OH', county: 'Butler' },
    { state: 'OH', county: 'Carroll' },
    { state: 'OH', county: 'Champaign' },
    { state: 'OH', county: 'Clark' },
    { state: 'OH', county: 'Clermont' },
    { state: 'OH', county: 'Clinton' },
    { state: 'OH', county: 'Columbiana' },
    { state: 'OH', county: 'Coshocton' },
    { state: 'OH', county: 'Crawford' },
    { state: 'OH', county: 'Cuyahoga' },
    { state: 'OH', county: 'Darke' },
    { state: 'OH', county: 'Defiance' },
    { state: 'OH', county: 'Delaware' },
    { state: 'OH', county: 'Erie' },
    { state: 'OH', county: 'Fairfield' },
    { state: 'OH', county: 'Fayette' },
    { state: 'OH', county: 'Franklin' },
    { state: 'OH', county: 'Fulton' },
    { state: 'OH', county: 'Gallia' },
    { state: 'OH', county: 'Geauga' },
    { state: 'OH', county: 'Greene' },
    { state: 'OH', county: 'Guernsey' },
    { state: 'OH', county: 'Hamilton' },
    { state: 'OH', county: 'Hancock' },
    { state: 'OH', county: 'Hardin' },
    { state: 'OH', county: 'Harrison' },
    { state: 'OH', county: 'Henry' },
    { state: 'OH', county: 'Highland' },
    { state: 'OH', county: 'Hocking' },
    { state: 'OH', county: 'Holmes' },
    { state: 'OH', county: 'Huron' },
    { state: 'OH', county: 'Jackson' },
    { state: 'OH', county: 'Jefferson' },
    { state: 'OH', county: 'Knox' },
    { state: 'OH', county: 'Lake' },
    { state: 'OH', county: 'Lawrence' },
    { state: 'OH', county: 'Licking' },
    { state: 'OH', county: 'Logan' },
    { state: 'OH', county: 'Lorain' },
    { state: 'OH', county: 'Lucas' },
    { state: 'OH', county: 'Madison' },
    { state: 'OH', county: 'Mahoning' },
    { state: 'OH', county: 'Marion' },
    { state: 'OH', county: 'Medina' },
    { state: 'OH', county: 'Meigs' },
    { state: 'OH', county: 'Mercer' },
    { state: 'OH', county: 'Miami' },
    { state: 'OH', county: 'Monroe' },
    { state: 'OH', county: 'Montgomery' },
    { state: 'OH', county: 'Morgan' },
    { state: 'OH', county: 'Morrow' },
    { state: 'OH', county: 'Muskingum' },
    { state: 'OH', county: 'Noble' },
    { state: 'OH', county: 'Ottawa' },
    { state: 'OH', county: 'Paulding' },
    { state: 'OH', county: 'Perry' },
    { state: 'OH', county: 'Pickaway' },
    { state: 'OH', county: 'Pike' },
    { state: 'OH', county: 'Portage' },
    { state: 'OH', county: 'Preble' },
    { state: 'OH', county: 'Putnam' },
    { state: 'OH', county: 'Richland' },
    { state: 'OH', county: 'Ross' },
    { state: 'OH', county: 'Sandusky' },
    { state: 'OH', county: 'Scioto' },
    { state: 'OH', county: 'Seneca' },
    { state: 'OH', county: 'Shelby' },
    { state: 'OH', county: 'Stark' },
    { state: 'OH', county: 'Summit' },
    { state: 'OH', county: 'Trumbull' },
    { state: 'OH', county: 'Tuscarawas' },
    { state: 'OH', county: 'Union' },
    { state: 'OH', county: 'Van Wert' },
    { state: 'OH', county: 'Vinton' },
    { state: 'OH', county: 'Warren' },
    { state: 'OH', county: 'Washington' },
    { state: 'OH', county: 'Wayne' },
    { state: 'OH', county: 'Williams' },
    { state: 'OH', county: 'Wood' },
    { state: 'OH', county: 'Wyandot' },
    { state: 'OK', county: 'Adair' },
    { state: 'OK', county: 'Alfalfa' },
    { state: 'OK', county: 'Atoka' },
    { state: 'OK', county: 'Beaver' },
    { state: 'OK', county: 'Beckham' },
    { state: 'OK', county: 'Blaine' },
    { state: 'OK', county: 'Bryan' },
    { state: 'OK', county: 'Caddo' },
    { state: 'OK', county: 'Canadian' },
    { state: 'OK', county: 'Carter' },
    { state: 'OK', county: 'Cherokee' },
    { state: 'OK', county: 'Choctaw' },
    { state: 'OK', county: 'Cimarron' },
    { state: 'OK', county: 'Cleveland' },
    { state: 'OK', county: 'Coal' },
    { state: 'OK', county: 'Comanche' },
    { state: 'OK', county: 'Cotton' },
    { state: 'OK', county: 'Craig' },
    { state: 'OK', county: 'Creek' },
    { state: 'OK', county: 'Custer' },
    { state: 'OK', county: 'Delaware' },
    { state: 'OK', county: 'Dewey' },
    { state: 'OK', county: 'Ellis' },
    { state: 'OK', county: 'Garfield' },
    { state: 'OK', county: 'Garvin' },
    { state: 'OK', county: 'Grady' },
    { state: 'OK', county: 'Grant' },
    { state: 'OK', county: 'Greer' },
    { state: 'OK', county: 'Harmon' },
    { state: 'OK', county: 'Harper' },
    { state: 'OK', county: 'Haskell' },
    { state: 'OK', county: 'Hughes' },
    { state: 'OK', county: 'Jackson' },
    { state: 'OK', county: 'Jefferson' },
    { state: 'OK', county: 'Johnston' },
    { state: 'OK', county: 'Kay' },
    { state: 'OK', county: 'Kingfisher' },
    { state: 'OK', county: 'Kiowa' },
    { state: 'OK', county: 'Latimer' },
    { state: 'OK', county: 'Le Flore' },
    { state: 'OK', county: 'Lincoln' },
    { state: 'OK', county: 'Logan' },
    { state: 'OK', county: 'Love' },
    { state: 'OK', county: 'McClain' },
    { state: 'OK', county: 'McCurtain' },
    { state: 'OK', county: 'McIntosh' },
    { state: 'OK', county: 'Major' },
    { state: 'OK', county: 'Marshall' },
    { state: 'OK', county: 'Mayes' },
    { state: 'OK', county: 'Murray' },
    { state: 'OK', county: 'Muskogee' },
    { state: 'OK', county: 'Noble' },
    { state: 'OK', county: 'Nowata' },
    { state: 'OK', county: 'Okfuskee' },
    { state: 'OK', county: 'Oklahoma' },
    { state: 'OK', county: 'Okmulgee' },
    { state: 'OK', county: 'Osage' },
    { state: 'OK', county: 'Ottawa' },
    { state: 'OK', county: 'Pawnee' },
    { state: 'OK', county: 'Payne' },
    { state: 'OK', county: 'Pittsburg' },
    { state: 'OK', county: 'Pontotoc' },
    { state: 'OK', county: 'Pottawatomie' },
    { state: 'OK', county: 'Pushmataha' },
    { state: 'OK', county: 'Roger Mills' },
    { state: 'OK', county: 'Rogers' },
    { state: 'OK', county: 'Seminole' },
    { state: 'OK', county: 'Sequoyah' },
    { state: 'OK', county: 'Stephens' },
    { state: 'OK', county: 'Texas' },
    { state: 'OK', county: 'Tillman' },
    { state: 'OK', county: 'Tulsa' },
    { state: 'OK', county: 'Wagoner' },
    { state: 'OK', county: 'Washington' },
    { state: 'OK', county: 'Washita' },
    { state: 'OK', county: 'Woods' },
    { state: 'OK', county: 'Woodward' },
    { state: 'OR', county: 'Baker' },
    { state: 'OR', county: 'Benton' },
    { state: 'OR', county: 'Clackamas' },
    { state: 'OR', county: 'Clatsop' },
    { state: 'OR', county: 'Columbia' },
    { state: 'OR', county: 'Coos' },
    { state: 'OR', county: 'Crook' },
    { state: 'OR', county: 'Curry' },
    { state: 'OR', county: 'Deschutes' },
    { state: 'OR', county: 'Douglas' },
    { state: 'OR', county: 'Gilliam' },
    { state: 'OR', county: 'Grant' },
    { state: 'OR', county: 'Harney' },
    { state: 'OR', county: 'Hood River' },
    { state: 'OR', county: 'Jackson' },
    { state: 'OR', county: 'Jefferson' },
    { state: 'OR', county: 'Josephine' },
    { state: 'OR', county: 'Klamath' },
    { state: 'OR', county: 'Lake' },
    { state: 'OR', county: 'Lane' },
    { state: 'OR', county: 'Lincoln' },
    { state: 'OR', county: 'Linn' },
    { state: 'OR', county: 'Malheur' },
    { state: 'OR', county: 'Marion' },
    { state: 'OR', county: 'Morrow' },
    { state: 'OR', county: 'Multnomah' },
    { state: 'OR', county: 'Polk' },
    { state: 'OR', county: 'Sherman' },
    { state: 'OR', county: 'Tillamook' },
    { state: 'OR', county: 'Umatilla' },
    { state: 'OR', county: 'Union' },
    { state: 'OR', county: 'Wallowa' },
    { state: 'OR', county: 'Wasco' },
    { state: 'OR', county: 'Washington' },
    { state: 'OR', county: 'Wheeler' },
    { state: 'OR', county: 'Yamhill' },
    { state: 'PA', county: 'Adams' },
    { state: 'PA', county: 'Allegheny' },
    { state: 'PA', county: 'Armstrong' },
    { state: 'PA', county: 'Beaver' },
    { state: 'PA', county: 'Bedford' },
    { state: 'PA', county: 'Berks' },
    { state: 'PA', county: 'Blair' },
    { state: 'PA', county: 'Bradford' },
    { state: 'PA', county: 'Bucks' },
    { state: 'PA', county: 'Butler' },
    { state: 'PA', county: 'Cambria' },
    { state: 'PA', county: 'Cameron' },
    { state: 'PA', county: 'Carbon' },
    { state: 'PA', county: 'Centre' },
    { state: 'PA', county: 'Chester' },
    { state: 'PA', county: 'Clarion' },
    { state: 'PA', county: 'Clearfield' },
    { state: 'PA', county: 'Clinton' },
    { state: 'PA', county: 'Columbia' },
    { state: 'PA', county: 'Crawford' },
    { state: 'PA', county: 'Cumberland' },
    { state: 'PA', county: 'Dauphin' },
    { state: 'PA', county: 'Delaware' },
    { state: 'PA', county: 'Elk' },
    { state: 'PA', county: 'Erie' },
    { state: 'PA', county: 'Fayette' },
    { state: 'PA', county: 'Forest' },
    { state: 'PA', county: 'Franklin' },
    { state: 'PA', county: 'Fulton' },
    { state: 'PA', county: 'Greene' },
    { state: 'PA', county: 'Huntingdon' },
    { state: 'PA', county: 'Idaho' },
    { state: 'PA', county: 'Jefferson' },
    { state: 'PA', county: 'Juniata' },
    { state: 'PA', county: 'Lackawanna' },
    { state: 'PA', county: 'Lancaster' },
    { state: 'PA', county: 'Lawrence' },
    { state: 'PA', county: 'Lebanon' },
    { state: 'PA', county: 'Lehigh' },
    { state: 'PA', county: 'Luzerne' },
    { state: 'PA', county: 'Lycoming' },
    { state: 'PA', county: 'McKean' },
    { state: 'PA', county: 'Mercer' },
    { state: 'PA', county: 'Mifflin' },
    { state: 'PA', county: 'Monroe' },
    { state: 'PA', county: 'Montgomery' },
    { state: 'PA', county: 'Montour' },
    { state: 'PA', county: 'Northampton' },
    { state: 'PA', county: 'Northumberland' },
    { state: 'PA', county: 'Perry' },
    { state: 'PA', county: 'Philadelphia' },
    { state: 'PA', county: 'Pike' },
    { state: 'PA', county: 'Potter' },
    { state: 'PA', county: 'Schuylkill' },
    { state: 'PA', county: 'Snyder' },
    { state: 'PA', county: 'Somerset' },
    { state: 'PA', county: 'Sullivan' },
    { state: 'PA', county: 'Susquehanna' },
    { state: 'PA', county: 'Tioga' },
    { state: 'PA', county: 'Union' },
    { state: 'PA', county: 'Venango' },
    { state: 'PA', county: 'Warren' },
    { state: 'PA', county: 'Washington' },
    { state: 'PA', county: 'Wayne' },
    { state: 'PA', county: 'Westmoreland' },
    { state: 'PA', county: 'Wyoming' },
    { state: 'PA', county: 'York' },
    { state: 'RI', county: 'Bristol' },
    { state: 'RI', county: 'Kent' },
    { state: 'RI', county: 'Newport' },
    { state: 'RI', county: 'Providence' },
    { state: 'RI', county: 'Washington' },
    { state: 'SC', county: 'Abbeville' },
    { state: 'SC', county: 'Aiken' },
    { state: 'SC', county: 'Allendale' },
    { state: 'SC', county: 'Anderson' },
    { state: 'SC', county: 'Bamberg' },
    { state: 'SC', county: 'Barnwell' },
    { state: 'SC', county: 'Beaufort' },
    { state: 'SC', county: 'Berkeley' },
    { state: 'SC', county: 'Calhoun' },
    { state: 'SC', county: 'Charleston' },
    { state: 'SC', county: 'Cherokee' },
    { state: 'SC', county: 'Chester' },
    { state: 'SC', county: 'Chesterfield' },
    { state: 'SC', county: 'Clarendon' },
    { state: 'SC', county: 'Colleton' },
    { state: 'SC', county: 'Darlington' },
    { state: 'SC', county: 'Dillon' },
    { state: 'SC', county: 'Dorchester' },
    { state: 'SC', county: 'Edgefield' },
    { state: 'SC', county: 'Fairfield' },
    { state: 'SC', county: 'Florence' },
    { state: 'SC', county: 'Georgetown' },
    { state: 'SC', county: 'Greenville' },
    { state: 'SC', county: 'Greenwood' },
    { state: 'SC', county: 'Hampton' },
    { state: 'SC', county: 'Horry' },
    { state: 'SC', county: 'Jasper' },
    { state: 'SC', county: 'Kershaw' },
    { state: 'SC', county: 'Lancaster' },
    { state: 'SC', county: 'Laurens' },
    { state: 'SC', county: 'Lee' },
    { state: 'SC', county: 'Lexington' },
    { state: 'SC', county: 'McCormick' },
    { state: 'SC', county: 'Marion' },
    { state: 'SC', county: 'Marlboro' },
    { state: 'SC', county: 'Newberry' },
    { state: 'SC', county: 'Oconee' },
    { state: 'SC', county: 'Orangeburg' },
    { state: 'SC', county: 'Pickens' },
    { state: 'SC', county: 'Richland' },
    { state: 'SC', county: 'Saluda' },
    { state: 'SC', county: 'Spartanburg' },
    { state: 'SC', county: 'Sumter' },
    { state: 'SC', county: 'Union' },
    { state: 'SC', county: 'Williamsburg' },
    { state: 'SC', county: 'York' },
    { state: 'SD', county: 'Aurora' },
    { state: 'SD', county: 'Beadle' },
    { state: 'SD', county: 'Bennett' },
    { state: 'SD', county: 'Bon Homme' },
    { state: 'SD', county: 'Brookings' },
    { state: 'SD', county: 'Brown' },
    { state: 'SD', county: 'Brule' },
    { state: 'SD', county: 'Buffalo' },
    { state: 'SD', county: 'Butte' },
    { state: 'SD', county: 'Campbell' },
    { state: 'SD', county: 'Charles Mix' },
    { state: 'SD', county: 'Clark' },
    { state: 'SD', county: 'Clay' },
    { state: 'SD', county: 'Codington' },
    { state: 'SD', county: 'Corson' },
    { state: 'SD', county: 'Custer' },
    { state: 'SD', county: 'Davison' },
    { state: 'SD', county: 'Day' },
    { state: 'SD', county: 'Deuel' },
    { state: 'SD', county: 'Dewey' },
    { state: 'SD', county: 'Douglas' },
    { state: 'SD', county: 'Edmunds' },
    { state: 'SD', county: 'Fall River' },
    { state: 'SD', county: 'Faulk' },
    { state: 'SD', county: 'Grant' },
    { state: 'SD', county: 'Gregory' },
    { state: 'SD', county: 'Haakon' },
    { state: 'SD', county: 'Hamlin' },
    { state: 'SD', county: 'Hand' },
    { state: 'SD', county: 'Hanson' },
    { state: 'SD', county: 'Harding' },
    { state: 'SD', county: 'Hughes' },
    { state: 'SD', county: 'Hutchinson' },
    { state: 'SD', county: 'Hyde' },
    { state: 'SD', county: 'Jackson' },
    { state: 'SD', county: 'Jerauld' },
    { state: 'SD', county: 'Jones' },
    { state: 'SD', county: 'Kingsbury' },
    { state: 'SD', county: 'Lake' },
    { state: 'SD', county: 'Lawrence' },
    { state: 'SD', county: 'Lincoln' },
    { state: 'SD', county: 'Lyman' },
    { state: 'SD', county: 'McCook' },
    { state: 'SD', county: 'McPherson' },
    { state: 'SD', county: 'Marshall' },
    { state: 'SD', county: 'Meade' },
    { state: 'SD', county: 'Mellette' },
    { state: 'SD', county: 'Miner' },
    { state: 'SD', county: 'Minnehaha' },
    { state: 'SD', county: 'Moody' },
    { state: 'SD', county: 'Pennington' },
    { state: 'SD', county: 'Perkins' },
    { state: 'SD', county: 'Potter' },
    { state: 'SD', county: 'Roberts' },
    { state: 'SD', county: 'Sanborn' },
    { state: 'SD', county: 'Shannon' },
    { state: 'SD', county: 'Spink' },
    { state: 'SD', county: 'Stanley' },
    { state: 'SD', county: 'Sully' },
    { state: 'SD', county: 'Todd' },
    { state: 'SD', county: 'Tripp' },
    { state: 'SD', county: 'Turner' },
    { state: 'SD', county: 'Union' },
    { state: 'SD', county: 'Walworth' },
    { state: 'SD', county: 'Yankton' },
    { state: 'SD', county: 'Ziebach' },
    { state: 'TN', county: 'Anderson' },
    { state: 'TN', county: 'Bedford' },
    { state: 'TN', county: 'Benton' },
    { state: 'TN', county: 'Bledsoe' },
    { state: 'TN', county: 'Blount' },
    { state: 'TN', county: 'Bradley' },
    { state: 'TN', county: 'Campbell' },
    { state: 'TN', county: 'Cannon' },
    { state: 'TN', county: 'Carroll' },
    { state: 'TN', county: 'Carter' },
    { state: 'TN', county: 'Cheatham' },
    { state: 'TN', county: 'Chester' },
    { state: 'TN', county: 'Claiborne' },
    { state: 'TN', county: 'Clay' },
    { state: 'TN', county: 'Cocke' },
    { state: 'TN', county: 'Coffee' },
    { state: 'TN', county: 'Crockett' },
    { state: 'TN', county: 'Cumberland' },
    { state: 'TN', county: 'Davidson' },
    { state: 'TN', county: 'Decatur' },
    { state: 'TN', county: 'DeKalb' },
    { state: 'TN', county: 'Dickson' },
    { state: 'TN', county: 'Dyer' },
    { state: 'TN', county: 'Fayette' },
    { state: 'TN', county: 'Fentress' },
    { state: 'TN', county: 'Franklin' },
    { state: 'TN', county: 'Gibson' },
    { state: 'TN', county: 'Giles' },
    { state: 'TN', county: 'Grainger' },
    { state: 'TN', county: 'Greene' },
    { state: 'TN', county: 'Grundy' },
    { state: 'TN', county: 'Hamblen' },
    { state: 'TN', county: 'Hamilton' },
    { state: 'TN', county: 'Hancock' },
    { state: 'TN', county: 'Hardeman' },
    { state: 'TN', county: 'Hardin' },
    { state: 'TN', county: 'Hawkins' },
    { state: 'TN', county: 'Haywood' },
    { state: 'TN', county: 'Henderson' },
    { state: 'TN', county: 'Henry' },
    { state: 'TN', county: 'Hickman' },
    { state: 'TN', county: 'Houston' },
    { state: 'TN', county: 'Humphreys' },
    { state: 'TN', county: 'Jackson' },
    { state: 'TN', county: 'Jefferson' },
    { state: 'TN', county: 'Johnson' },
    { state: 'TN', county: 'Knox' },
    { state: 'TN', county: 'Lake' },
    { state: 'TN', county: 'Lauderdale' },
    { state: 'TN', county: 'Lawrence' },
    { state: 'TN', county: 'Lewis' },
    { state: 'TN', county: 'Lincoln' },
    { state: 'TN', county: 'Loudon' },
    { state: 'TN', county: 'McMinn' },
    { state: 'TN', county: 'McNairy' },
    { state: 'TN', county: 'Macon' },
    { state: 'TN', county: 'Madison' },
    { state: 'TN', county: 'Marion' },
    { state: 'TN', county: 'Marshall' },
    { state: 'TN', county: 'Maury' },
    { state: 'TN', county: 'Meigs' },
    { state: 'TN', county: 'Monroe' },
    { state: 'TN', county: 'Montgomery' },
    { state: 'TN', county: 'Moore' },
    { state: 'TN', county: 'Morgan' },
    { state: 'TN', county: 'Obion' },
    { state: 'TN', county: 'Overton' },
    { state: 'TN', county: 'Perry' },
    { state: 'TN', county: 'Pickett' },
    { state: 'TN', county: 'Polk' },
    { state: 'TN', county: 'Putnam' },
    { state: 'TN', county: 'Rhea' },
    { state: 'TN', county: 'Roane' },
    { state: 'TN', county: 'Robertson' },
    { state: 'TN', county: 'Rutherford' },
    { state: 'TN', county: 'Scott' },
    { state: 'TN', county: 'Sequatchie' },
    { state: 'TN', county: 'Sevier' },
    { state: 'TN', county: 'Shelby' },
    { state: 'TN', county: 'Smith' },
    { state: 'TN', county: 'Stewart' },
    { state: 'TN', county: 'Sullivan' },
    { state: 'TN', county: 'Sumner' },
    { state: 'TN', county: 'Tipton' },
    { state: 'TN', county: 'Trousdale' },
    { state: 'TN', county: 'Unicoi' },
    { state: 'TN', county: 'Union' },
    { state: 'TN', county: 'Van Buren' },
    { state: 'TN', county: 'Warren' },
    { state: 'TN', county: 'Washington' },
    { state: 'TN', county: 'Wayne' },
    { state: 'TN', county: 'Weakley' },
    { state: 'TN', county: 'White' },
    { state: 'TN', county: 'Williamson' },
    { state: 'TN', county: 'Wilson' },
    { state: 'TX', county: 'Anderson' },
    { state: 'TX', county: 'Andrews' },
    { state: 'TX', county: 'Angelina' },
    { state: 'TX', county: 'Aransas' },
    { state: 'TX', county: 'Archer' },
    { state: 'TX', county: 'Armstrong' },
    { state: 'TX', county: 'Atascosa' },
    { state: 'TX', county: 'Austin' },
    { state: 'TX', county: 'Bailey' },
    { state: 'TX', county: 'Bandera' },
    { state: 'TX', county: 'Bastrop' },
    { state: 'TX', county: 'Baylor' },
    { state: 'TX', county: 'Bee' },
    { state: 'TX', county: 'Bell' },
    { state: 'TX', county: 'Bexar' },
    { state: 'TX', county: 'Blanco' },
    { state: 'TX', county: 'Borden' },
    { state: 'TX', county: 'Bosque' },
    { state: 'TX', county: 'Bowie' },
    { state: 'TX', county: 'Brazoria' },
    { state: 'TX', county: 'Brazos' },
    { state: 'TX', county: 'Brewster' },
    { state: 'TX', county: 'Briscoe' },
    { state: 'TX', county: 'Brooks' },
    { state: 'TX', county: 'Brown' },
    { state: 'TX', county: 'Burleson' },
    { state: 'TX', county: 'Burnet' },
    { state: 'TX', county: 'Caldwell' },
    { state: 'TX', county: 'Calhoun' },
    { state: 'TX', county: 'Callahan' },
    { state: 'TX', county: 'Cameron' },
    { state: 'TX', county: 'Camp' },
    { state: 'TX', county: 'Carson' },
    { state: 'TX', county: 'Cass' },
    { state: 'TX', county: 'Castro' },
    { state: 'TX', county: 'Chambers' },
    { state: 'TX', county: 'Cherokee' },
    { state: 'TX', county: 'Childress' },
    { state: 'TX', county: 'Clay' },
    { state: 'TX', county: 'Cochran' },
    { state: 'TX', county: 'Coke' },
    { state: 'TX', county: 'Coleman' },
    { state: 'TX', county: 'Collin' },
    { state: 'TX', county: 'Collingsworth' },
    { state: 'TX', county: 'CO' },
    { state: 'TX', county: 'Comal' },
    { state: 'TX', county: 'Comanche' },
    { state: 'TX', county: 'Concho' },
    { state: 'TX', county: 'Cooke' },
    { state: 'TX', county: 'Coryell' },
    { state: 'TX', county: 'Cottle' },
    { state: 'TX', county: 'Crane' },
    { state: 'TX', county: 'Crockett' },
    { state: 'TX', county: 'Crosby' },
    { state: 'TX', county: 'Culberson' },
    { state: 'TX', county: 'Dallam' },
    { state: 'TX', county: 'Dallas' },
    { state: 'TX', county: 'Dawson' },
    { state: 'TX', county: 'Deaf Smith' },
    { state: 'TX', county: 'Delta' },
    { state: 'TX', county: 'Denton' },
    { state: 'TX', county: 'DeWitt' },
    { state: 'TX', county: 'Dickens' },
    { state: 'TX', county: 'Dimmit' },
    { state: 'TX', county: 'Donley' },
    { state: 'TX', county: 'Duval' },
    { state: 'TX', county: 'Eastland' },
    { state: 'TX', county: 'Ector' },
    { state: 'TX', county: 'Edwards' },
    { state: 'TX', county: 'Ellis' },
    { state: 'TX', county: 'El Paso' },
    { state: 'TX', county: 'Erath' },
    { state: 'TX', county: 'Falls' },
    { state: 'TX', county: 'Fannin' },
    { state: 'TX', county: 'Fayette' },
    { state: 'TX', county: 'Fisher' },
    { state: 'TX', county: 'Floyd' },
    { state: 'TX', county: 'Foard' },
    { state: 'TX', county: 'Fort Bend' },
    { state: 'TX', county: 'Franklin' },
    { state: 'TX', county: 'Freestone' },
    { state: 'TX', county: 'Frio' },
    { state: 'TX', county: 'Gaines' },
    { state: 'TX', county: 'Galveston' },
    { state: 'TX', county: 'Garza' },
    { state: 'TX', county: 'Gillespie' },
    { state: 'TX', county: 'Glasscock' },
    { state: 'TX', county: 'Goliad' },
    { state: 'TX', county: 'Gonzales' },
    { state: 'TX', county: 'Gray' },
    { state: 'TX', county: 'Grayson' },
    { state: 'TX', county: 'Gregg' },
    { state: 'TX', county: 'Grimes' },
    { state: 'TX', county: 'Guadalupe' },
    { state: 'TX', county: 'Hale' },
    { state: 'TX', county: 'Hall' },
    { state: 'TX', county: 'Hamilton' },
    { state: 'TX', county: 'Hansford' },
    { state: 'TX', county: 'Hardeman' },
    { state: 'TX', county: 'Hardin' },
    { state: 'TX', county: 'Harris' },
    { state: 'TX', county: 'Harrison' },
    { state: 'TX', county: 'Hartley' },
    { state: 'TX', county: 'Haskell' },
    { state: 'TX', county: 'Hays' },
    { state: 'TX', county: 'Hemphill' },
    { state: 'TX', county: 'Henderson' },
    { state: 'TX', county: 'Hidalgo' },
    { state: 'TX', county: 'Hill' },
    { state: 'TX', county: 'Hockley' },
    { state: 'TX', county: 'Hood' },
    { state: 'TX', county: 'Hopkins' },
    { state: 'TX', county: 'Houston' },
    { state: 'TX', county: 'Howard' },
    { state: 'TX', county: 'Hudspeth' },
    { state: 'TX', county: 'Hunt' },
    { state: 'TX', county: 'Hutchinson' },
    { state: 'TX', county: 'Irion' },
    { state: 'TX', county: 'Jack' },
    { state: 'TX', county: 'Jackson' },
    { state: 'TX', county: 'Jasper' },
    { state: 'TX', county: 'Jeff Davis' },
    { state: 'TX', county: 'Jefferson' },
    { state: 'TX', county: 'Jim Hogg' },
    { state: 'TX', county: 'Jim Wells' },
    { state: 'TX', county: 'Johnson' },
    { state: 'TX', county: 'Jones' },
    { state: 'TX', county: 'Karnes' },
    { state: 'TX', county: 'Kaufman' },
    { state: 'TX', county: 'Kendall' },
    { state: 'TX', county: 'Kenedy' },
    { state: 'TX', county: 'Kent' },
    { state: 'TX', county: 'Kerr' },
    { state: 'TX', county: 'Kimble' },
    { state: 'TX', county: 'King' },
    { state: 'TX', county: 'Kinney' },
    { state: 'TX', county: 'Kleberg' },
    { state: 'TX', county: 'Knox' },
    { state: 'TX', county: 'Lamar' },
    { state: 'TX', county: 'Lamb' },
    { state: 'TX', county: 'Lampasas' },
    { state: 'TX', county: 'La Salle' },
    { state: 'TX', county: 'Lavaca' },
    { state: 'TX', county: 'Lee' },
    { state: 'TX', county: 'Leon' },
    { state: 'TX', county: 'Liberty' },
    { state: 'TX', county: 'Limestone' },
    { state: 'TX', county: 'Lipscomb' },
    { state: 'TX', county: 'Live Oak' },
    { state: 'TX', county: 'Llano' },
    { state: 'TX', county: 'Loving' },
    { state: 'TX', county: 'Lubbock' },
    { state: 'TX', county: 'Lynn' },
    { state: 'TX', county: 'McCulloch' },
    { state: 'TX', county: 'McLennan' },
    { state: 'TX', county: 'McMullen' },
    { state: 'TX', county: 'Madison' },
    { state: 'TX', county: 'Marion' },
    { state: 'TX', county: 'Martin' },
    { state: 'TX', county: 'Mason' },
    { state: 'TX', county: 'Matagorda' },
    { state: 'TX', county: 'Maverick' },
    { state: 'TX', county: 'Medina' },
    { state: 'TX', county: 'Menard' },
    { state: 'TX', county: 'Midland' },
    { state: 'TX', county: 'Milam' },
    { state: 'TX', county: 'Mills' },
    { state: 'TX', county: 'Mitchell' },
    { state: 'TX', county: 'Montague' },
    { state: 'TX', county: 'Montgomery' },
    { state: 'TX', county: 'Moore' },
    { state: 'TX', county: 'Morris' },
    { state: 'TX', county: 'Motley' },
    { state: 'TX', county: 'Nacogdoches' },
    { state: 'TX', county: 'Navarro' },
    { state: 'TX', county: 'Newton' },
    { state: 'TX', county: 'Nolan' },
    { state: 'TX', county: 'Nueces' },
    { state: 'TX', county: 'Ochiltree' },
    { state: 'TX', county: 'Oldham' },
    { state: 'TX', county: 'Orange' },
    { state: 'TX', county: 'Palo Pinto' },
    { state: 'TX', county: 'Panola' },
    { state: 'TX', county: 'Parker' },
    { state: 'TX', county: 'Parmer' },
    { state: 'TX', county: 'Pecos' },
    { state: 'TX', county: 'Polk' },
    { state: 'TX', county: 'Potter' },
    { state: 'TX', county: 'Presidio' },
    { state: 'TX', county: 'Rains' },
    { state: 'TX', county: 'Randall' },
    { state: 'TX', county: 'Reagan' },
    { state: 'TX', county: 'Real' },
    { state: 'TX', county: 'Red River' },
    { state: 'TX', county: 'Reeves' },
    { state: 'TX', county: 'Refugio' },
    { state: 'TX', county: 'Roberts' },
    { state: 'TX', county: 'Robertson' },
    { state: 'TX', county: 'Rockwall' },
    { state: 'TX', county: 'Runnels' },
    { state: 'TX', county: 'Rusk' },
    { state: 'TX', county: 'Sabine' },
    { state: 'TX', county: 'San Augustine' },
    { state: 'TX', county: 'San Jacinto' },
    { state: 'TX', county: 'San Patricio' },
    { state: 'TX', county: 'San Saba' },
    { state: 'TX', county: 'Schleicher' },
    { state: 'TX', county: 'Scurry' },
    { state: 'TX', county: 'Shackelford' },
    { state: 'TX', county: 'Shelby' },
    { state: 'TX', county: 'Sherman' },
    { state: 'TX', county: 'Smith' },
    { state: 'TX', county: 'Somervell' },
    { state: 'TX', county: 'Starr' },
    { state: 'TX', county: 'Stephens' },
    { state: 'TX', county: 'Sterling' },
    { state: 'TX', county: 'Stonewall' },
    { state: 'TX', county: 'Sutton' },
    { state: 'TX', county: 'Swisher' },
    { state: 'TX', county: 'Tarrant' },
    { state: 'TX', county: 'Taylor' },
    { state: 'TX', county: 'Terrell' },
    { state: 'TX', county: 'Terry' },
    { state: 'TX', county: 'Throckmorton' },
    { state: 'TX', county: 'Titus' },
    { state: 'TX', county: 'Tom Green' },
    { state: 'TX', county: 'Travis' },
    { state: 'TX', county: 'Trinity' },
    { state: 'TX', county: 'Tyler' },
    { state: 'TX', county: 'Upshur' },
    { state: 'TX', county: 'Upton' },
    { state: 'TX', county: 'Uvalde' },
    { state: 'TX', county: 'Val Verde' },
    { state: 'TX', county: 'Van Zandt' },
    { state: 'TX', county: 'Victoria' },
    { state: 'TX', county: 'Walker' },
    { state: 'TX', county: 'Waller' },
    { state: 'TX', county: 'Ward' },
    { state: 'TX', county: 'Washington' },
    { state: 'TX', county: 'Webb' },
    { state: 'TX', county: 'Wharton' },
    { state: 'TX', county: 'Wheeler' },
    { state: 'TX', county: 'Wichita' },
    { state: 'TX', county: 'Wilbarger' },
    { state: 'TX', county: 'Willacy' },
    { state: 'TX', county: 'Williamson' },
    { state: 'TX', county: 'Wilson' },
    { state: 'TX', county: 'Winkler' },
    { state: 'TX', county: 'Wise' },
    { state: 'TX', county: 'Wood' },
    { state: 'TX', county: 'Yoakum' },
    { state: 'TX', county: 'Young' },
    { state: 'TX', county: 'Zapata' },
    { state: 'TX', county: 'Zavala' },
    { state: 'UT', county: 'Beaver' },
    { state: 'UT', county: 'Box Elder' },
    { state: 'UT', county: 'Cache' },
    { state: 'UT', county: 'Carbon' },
    { state: 'UT', county: 'Daggett' },
    { state: 'UT', county: 'Davis' },
    { state: 'UT', county: 'Duchesne' },
    { state: 'UT', county: 'Emery' },
    { state: 'UT', county: 'Garfield' },
    { state: 'UT', county: 'Grand' },
    { state: 'UT', county: 'Iron' },
    { state: 'UT', county: 'Juab' },
    { state: 'UT', county: 'Kane' },
    { state: 'UT', county: 'Millard' },
    { state: 'UT', county: 'Morgan' },
    { state: 'UT', county: 'Piute' },
    { state: 'UT', county: 'Rich' },
    { state: 'UT', county: 'Salt Lake' },
    { state: 'UT', county: 'San Juan' },
    { state: 'UT', county: 'Sanpete' },
    { state: 'UT', county: 'Sevier' },
    { state: 'UT', county: 'Summit' },
    { state: 'UT', county: 'Tooele' },
    { state: 'UT', county: 'Uintah' },
    { state: 'UT', county: 'Utah' },
    { state: 'UT', county: 'Wasatch' },
    { state: 'UT', county: 'Washington' },
    { state: 'UT', county: 'Wayne' },
    { state: 'UT', county: 'Weber' },
    { state: 'VT', county: 'Addison' },
    { state: 'VT', county: 'Bennington' },
    { state: 'VT', county: 'Caledonia' },
    { state: 'VT', county: 'Chittenden' },
    { state: 'VT', county: 'Essex' },
    { state: 'VT', county: 'Franklin' },
    { state: 'VT', county: 'Grand Isle' },
    { state: 'VT', county: 'Lamoille' },
    { state: 'VT', county: 'Orange' },
    { state: 'VT', county: 'Orleans' },
    { state: 'VT', county: 'Rutland' },
    { state: 'VT', county: 'Washington' },
    { state: 'VT', county: 'Windham' },
    { state: 'VT', county: 'Windsor' },
    { state: 'VA', county: 'Accomack' },
    { state: 'VA', county: 'Albemarle' },
    { state: 'VA', county: 'Alleghany' },
    { state: 'VA', county: 'Amelia' },
    { state: 'VA', county: 'Amherst' },
    { state: 'VA', county: 'Appomattox' },
    { state: 'VA', county: 'Arlington' },
    { state: 'VA', county: 'Augusta' },
    { state: 'VA', county: 'Bath' },
    { state: 'VA', county: 'Bedford' },
    { state: 'VA', county: 'Bland' },
    { state: 'VA', county: 'Botetourt' },
    { state: 'VA', county: 'Brunswick' },
    { state: 'VA', county: 'Buchanan' },
    { state: 'VA', county: 'Buckingham' },
    { state: 'VA', county: 'Campbell' },
    { state: 'VA', county: 'Caroline' },
    { state: 'VA', county: 'Carroll' },
    { state: 'VA', county: 'Charles City' },
    { state: 'VA', county: 'Charlotte' },
    { state: 'VA', county: 'Chesterfield' },
    { state: 'VA', county: 'Clarke' },
    { state: 'VA', county: 'Craig' },
    { state: 'VA', county: 'Culpeper' },
    { state: 'VA', county: 'Cumberland' },
    { state: 'VA', county: 'Dickenson' },
    { state: 'VA', county: 'Dinwiddie' },
    { state: 'VA', county: 'Essex' },
    { state: 'VA', county: 'Fairfax' },
    { state: 'VA', county: 'Fauquier' },
    { state: 'VA', county: 'Floyd' },
    { state: 'VA', county: 'Fluvanna' },
    { state: 'VA', county: 'Franklin' },
    { state: 'VA', county: 'Frederick' },
    { state: 'VA', county: 'Giles' },
    { state: 'VA', county: 'Gloucester' },
    { state: 'VA', county: 'Goochland' },
    { state: 'VA', county: 'Grayson' },
    { state: 'VA', county: 'Greene' },
    { state: 'VA', county: 'Greensville' },
    { state: 'VA', county: 'Halifax' },
    { state: 'VA', county: 'Hanover' },
    { state: 'VA', county: 'Henrico' },
    { state: 'VA', county: 'Henry' },
    { state: 'VA', county: 'Highland' },
    { state: 'VA', county: 'Isle Of Wight' },
    { state: 'VA', county: 'James City' },
    { state: 'VA', county: 'King And Queen' },
    { state: 'VA', county: 'King George' },
    { state: 'VA', county: 'King William' },
    { state: 'VA', county: 'Lancaster' },
    { state: 'VA', county: 'Lee' },
    { state: 'VA', county: 'Loudoun' },
    { state: 'VA', county: 'Louisa' },
    { state: 'VA', county: 'Lunenburg' },
    { state: 'VA', county: 'Madison' },
    { state: 'VA', county: 'Mathews' },
    { state: 'VA', county: 'Mecklenburg' },
    { state: 'VA', county: 'Middlesex' },
    { state: 'VA', county: 'Montgomery' },
    { state: 'VA', county: 'Nelson' },
    { state: 'VA', county: 'New Kent' },
    { state: 'VA', county: 'Northampton' },
    { state: 'VA', county: 'Northumberland' },
    { state: 'VA', county: 'Nottoway' },
    { state: 'VA', county: 'Orange' },
    { state: 'VA', county: 'Page' },
    { state: 'VA', county: 'Patrick' },
    { state: 'VA', county: 'Pittsylvania' },
    { state: 'VA', county: 'Powhatan' },
    { state: 'VA', county: 'Prince Edward' },
    { state: 'VA', county: 'Prince George' },
    { state: 'VA', county: 'Prince William' },
    { state: 'VA', county: 'Pulaski' },
    { state: 'VA', county: 'Rappahannock' },
    { state: 'VA', county: 'Richmond' },
    { state: 'VA', county: 'Roanoke' },
    { state: 'VA', county: 'Rockbridge' },
    { state: 'VA', county: 'Rockingham' },
    { state: 'VA', county: 'Russell' },
    { state: 'VA', county: 'Scott' },
    { state: 'VA', county: 'Shenandoah' },
    { state: 'VA', county: 'Smyth' },
    { state: 'VA', county: 'Southampton' },
    { state: 'VA', county: 'Spotsylvania' },
    { state: 'VA', county: 'Stafford' },
    { state: 'VA', county: 'Surry' },
    { state: 'VA', county: 'Sussex' },
    { state: 'VA', county: 'Tazewell' },
    { state: 'VA', county: 'Warren' },
    { state: 'VA', county: 'Washington' },
    { state: 'VA', county: 'Westmoreland' },
    { state: 'VA', county: 'Wise' },
    { state: 'VA', county: 'Wythe' },
    { state: 'VA', county: 'York' },
    { state: 'WA', county: 'Adams' },
    { state: 'WA', county: 'Asotin' },
    { state: 'WA', county: 'Benton' },
    { state: 'WA', county: 'Chelan' },
    { state: 'WA', county: 'Clallam' },
    { state: 'WA', county: 'Clark' },
    { state: 'WA', county: 'Columbia' },
    { state: 'WA', county: 'Cowlitz' },
    { state: 'WA', county: 'Douglas' },
    { state: 'WA', county: 'Ferry' },
    { state: 'WA', county: 'Franklin' },
    { state: 'WA', county: 'Garfield' },
    { state: 'WA', county: 'Grant' },
    { state: 'WA', county: 'Grays Harbor' },
    { state: 'WA', county: 'Island' },
    { state: 'WA', county: 'Jefferson' },
    { state: 'WA', county: 'King' },
    { state: 'WA', county: 'Kitsap' },
    { state: 'WA', county: 'Kittitas' },
    { state: 'WA', county: 'Klickitat' },
    { state: 'WA', county: 'Lewis' },
    { state: 'WA', county: 'Lincoln' },
    { state: 'WA', county: 'Mason' },
    { state: 'WA', county: 'Okanogan' },
    { state: 'WA', county: 'Pacific' },
    { state: 'WA', county: 'Pend Oreille' },
    { state: 'WA', county: 'Pierce' },
    { state: 'WA', county: 'San Juan' },
    { state: 'WA', county: 'Skagit' },
    { state: 'WA', county: 'Skamania' },
    { state: 'WA', county: 'Snohomish' },
    { state: 'WA', county: 'Spokane' },
    { state: 'WA', county: 'Stevens' },
    { state: 'WA', county: 'Thurston' },
    { state: 'WA', county: 'Wahkiakum' },
    { state: 'WA', county: 'Walla Walla' },
    { state: 'WA', county: 'Whatcom' },
    { state: 'WA', county: 'Whitman' },
    { state: 'WA', county: 'Yakima' },
    { state: 'WV', county: 'Barbour' },
    { state: 'WV', county: 'Berkeley' },
    { state: 'WV', county: 'Boone' },
    { state: 'WV', county: 'Braxton' },
    { state: 'WV', county: 'Brooke' },
    { state: 'WV', county: 'Cabell' },
    { state: 'WV', county: 'Calhoun' },
    { state: 'WV', county: 'Clay' },
    { state: 'WV', county: 'Doddridge' },
    { state: 'WV', county: 'Fayette' },
    { state: 'WV', county: 'Gilmer' },
    { state: 'WV', county: 'Grant' },
    { state: 'WV', county: 'Greenbrier' },
    { state: 'WV', county: 'Hampshire' },
    { state: 'WV', county: 'Hancock' },
    { state: 'WV', county: 'Hardy' },
    { state: 'WV', county: 'Harrison' },
    { state: 'WV', county: 'Jackson' },
    { state: 'WV', county: 'Jefferson' },
    { state: 'WV', county: 'Kanawha' },
    { state: 'WV', county: 'Lewis' },
    { state: 'WV', county: 'Lincoln' },
    { state: 'WV', county: 'Logan' },
    { state: 'WV', county: 'McDowell' },
    { state: 'WV', county: 'Marion' },
    { state: 'WV', county: 'Marshall' },
    { state: 'WV', county: 'Mason' },
    { state: 'WV', county: 'Mercer' },
    { state: 'WV', county: 'Mineral' },
    { state: 'WV', county: 'Mingo' },
    { state: 'WV', county: 'Monongalia' },
    { state: 'WV', county: 'Monroe' },
    { state: 'WV', county: 'Morgan' },
    { state: 'WV', county: 'Nicholas' },
    { state: 'WV', county: 'Ohio' },
    { state: 'WV', county: 'Pendleton' },
    { state: 'WV', county: 'Pleasants' },
    { state: 'WV', county: 'Pocahontas' },
    { state: 'WV', county: 'Preston' },
    { state: 'WV', county: 'Putnam' },
    { state: 'WV', county: 'Raleigh' },
    { state: 'WV', county: 'Randolph' },
    { state: 'WV', county: 'Ritchie' },
    { state: 'WV', county: 'Roane' },
    { state: 'WV', county: 'Summers' },
    { state: 'WV', county: 'Taylor' },
    { state: 'WV', county: 'Tucker' },
    { state: 'WV', county: 'Tyler' },
    { state: 'WV', county: 'Upshur' },
    { state: 'WV', county: 'Wayne' },
    { state: 'WV', county: 'Webster' },
    { state: 'WV', county: 'Wetzel' },
    { state: 'WV', county: 'Wirt' },
    { state: 'WV', county: 'Wood' },
    { state: 'WV', county: 'Wyoming' },
    { state: 'WI', county: 'Adams' },
    { state: 'WI', county: 'Ashland' },
    { state: 'WI', county: 'Barron' },
    { state: 'WI', county: 'Bayfield' },
    { state: 'WI', county: 'Brown' },
    { state: 'WI', county: 'Buffalo' },
    { state: 'WI', county: 'Burnett' },
    { state: 'WI', county: 'Calumet' },
    { state: 'WI', county: 'Chippewa' },
    { state: 'WI', county: 'Clark' },
    { state: 'WI', county: 'Columbia' },
    { state: 'WI', county: 'Crawford' },
    { state: 'WI', county: 'Dane' },
    { state: 'WI', county: 'Dodge' },
    { state: 'WI', county: 'Door' },
    { state: 'WI', county: 'Douglas' },
    { state: 'WI', county: 'Dunn' },
    { state: 'WI', county: 'Eau Claire' },
    { state: 'WI', county: 'Florence' },
    { state: 'WI', county: 'Fond Du Lac' },
    { state: 'WI', county: 'Forest' },
    { state: 'WI', county: 'Grant' },
    { state: 'WI', county: 'Green' },
    { state: 'WI', county: 'Green Lake' },
    { state: 'WI', county: 'Iowa' },
    { state: 'WI', county: 'Iron' },
    { state: 'WI', county: 'Jackson' },
    { state: 'WI', county: 'Jefferson' },
    { state: 'WI', county: 'Juneau' },
    { state: 'WI', county: 'Kenosha' },
    { state: 'WI', county: 'Kewaunee' },
    { state: 'WI', county: 'La Crosse' },
    { state: 'WI', county: 'Lafayette' },
    { state: 'WI', county: 'Langlade' },
    { state: 'WI', county: 'Lincoln' },
    { state: 'WI', county: 'Manitowoc' },
    { state: 'WI', county: 'Marathon' },
    { state: 'WI', county: 'Marinette' },
    { state: 'WI', county: 'Marquette' },
    { state: 'WI', county: 'Menominee' },
    { state: 'WI', county: 'Milwaukee' },
    { state: 'WI', county: 'Monroe' },
    { state: 'WI', county: 'Oconto' },
    { state: 'WI', county: 'Oneida' },
    { state: 'WI', county: 'Outagamie' },
    { state: 'WI', county: 'Ozaukee' },
    { state: 'WI', county: 'Pepin' },
    { state: 'WI', county: 'Pierce' },
    { state: 'WI', county: 'Polk' },
    { state: 'WI', county: 'Portage' },
    { state: 'WI', county: 'Price' },
    { state: 'WI', county: 'Racine' },
    { state: 'WI', county: 'Richland' },
    { state: 'WI', county: 'Rock' },
    { state: 'WI', county: 'Rusk' },
    { state: 'WI', county: 'St. Croix' },
    { state: 'WI', county: 'Sauk' },
    { state: 'WI', county: 'Sawyer' },
    { state: 'WI', county: 'Shawano' },
    { state: 'WI', county: 'Sheboygan' },
    { state: 'WI', county: 'Taylor' },
    { state: 'WI', county: 'Trempealeau' },
    { state: 'WI', county: 'Vernon' },
    { state: 'WI', county: 'Vilas' },
    { state: 'WI', county: 'Walworth' },
    { state: 'WI', county: 'Washburn' },
    { state: 'WI', county: 'Washington' },
    { state: 'WI', county: 'Waukesha' },
    { state: 'WI', county: 'Waupaca' },
    { state: 'WI', county: 'Waushara' },
    { state: 'WI', county: 'Winnebago' },
    { state: 'WI', county: 'Wood' },
    { state: 'WY', county: 'Albany' },
    { state: 'WY', county: 'Big Horn' },
    { state: 'WY', county: 'Campbell' },
    { state: 'WY', county: 'Carbon' },
    { state: 'WY', county: 'Converse' },
    { state: 'WY', county: 'Crook' },
    { state: 'WY', county: 'Fremont' },
    { state: 'WY', county: 'Goshen' },
    { state: 'WY', county: 'Hot Springs' },
    { state: 'WY', county: 'Johnson' },
    { state: 'WY', county: 'Laramie' },
    { state: 'WY', county: 'Lincoln' },
    { state: 'WY', county: 'Natrona' },
    { state: 'WY', county: 'Niobrara' },
    { state: 'WY', county: 'Park' },
    { state: 'WY', county: 'Platte' },
    { state: 'WY', county: 'Sheridan' },
    { state: 'WY', county: 'Sublette' },
    { state: 'WY', county: 'Sweetwater' },
    { state: 'WY', county: 'Teton' },
    { state: 'WY', county: 'Uinta' },
    { state: 'WY', county: 'Washakie' },
    { state: 'WY', county: 'Weston' },
];
